<div class="crud-container">
  <div class="crud-header">
    <div class="crud-title-wrapper">
      <h2>{{ "MAIN_SIDEBAR.DETAILS_SIDEBAR.SETTINGS.ROLE_AND_PERMISSIONS" | translate }}</h2>
      <p>{{ "MAIN_SIDEBAR.MESSAGE" | translate }}</p>
    </div>
    <div class="buttons-wrapper" *ngIf="permissionsService.isRoleManagementCreateEditAllowed">
      <button data-bs-toggle="modal" data-bs-target="#addRoleModal" class="add-new" (click)="openAddNewRole()">{{
        "ROLE_MANAGEMENT.ADD_ROLE" | translate }}</button>
    </div>
  </div>

  <div class="crud-body">
    <div class="categories-sidebar">
      <app-role-and-permissions-sidebar *ngIf="roles.length > 0" (itemSelected)="onSidebarItemSelected($event)"
        [sidebarItems]="roles"></app-role-and-permissions-sidebar>
    </div>
    <div class="crud-content">
      <div class="content-header">
        <div class="content-title">
          <span>{{ currentRole.name }} {{ 'ROLE_MANAGEMENT.PERMISSIONS' | translate }}</span>
        </div>
        <div class="content-actions">
          <button [disabled]="!saveChangesAllowed"
            [style.background-color]="saveChangesAllowed ? 'var(--primary-color)' : 'var(--card-color)'"
            class="save-changes-btn" (click)="saveChanges()">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
        </div>
      </div>
      <div class="content-body">
        <!-- ADMIN PERMISSIONS -->
        <div *ngIf="currentRole.systemComponent == 0"
          [ngClass]="{ 'disable-div': !permissionsService.isRoleManagementCreateEditAllowed }">
          <!-- DASHBOARD -->
          <div class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="permission-header">
              <h3 class="permission-title">Dashboard</h3>
              <label class="switch">
                <input type="checkbox" [checked]="
                          isChecked([
                              PermissionsEnum.Dashboard_AnalyticsOverview,
                              PermissionsEnum.Dashboard_OperationsAnalytics,
                              PermissionsEnum.Dashboard_MeterValidation,
                          ])" (change)="
                          onChangePermission(
                              [
                                  PermissionsEnum.Dashboard_AnalyticsOverview,
                                  PermissionsEnum.Dashboard_OperationsAnalytics,
                                  PermissionsEnum.Dashboard_MeterValidation,            
                              ],
                              $event
                          )
                      " />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="analytics-overview" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Dashboard_AnalyticsOverview])"
                  (change)="onChangePermission([PermissionsEnum.Dashboard_AnalyticsOverview], $event)">
                <label for="analytics-overview" class="permission-label">{{ "DASHBOARD.ANALYTICS_OVERVIEW.TITLE" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="operations-analytics" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Dashboard_OperationsAnalytics])"
                  (change)="onChangePermission([PermissionsEnum.Dashboard_OperationsAnalytics], $event)">
                <label for="operations-analytics" class="permission-label">{{ "DASHBOARD.OPERATIONS_ANALYTICS.TITLE" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="meter-validation" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Dashboard_MeterValidation])"
                  (change)="onChangePermission([PermissionsEnum.Dashboard_MeterValidation], $event)">
                <label for="meter-validation" class="permission-label">{{ "SIDENAV.METER_VALIDATION" | translate
                  }}</label>
              </div>

            </div>
          </div>
          <!-- AI -->
          <div *ngIf="permissionsService.hasDashboardConfigAIDroneMap"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="permission-header">
              <h3 class="permission-title">{{ 'SIDENAV.AI_UAV' | translate }}</h3>
              <label class="switch">
                <input type="checkbox" [checked]="
                          isChecked([
                              PermissionsEnum.AI_UAV_Overview,
                              PermissionsEnum.AI_UAV_Batch_Image_Import,
                              PermissionsEnum.AI_UAV_Segmentation_List,
                              PermissionsEnum.AI_UAV_Job_Monitoring
                          ])" (change)="
                          onChangePermission(
                              [
                                PermissionsEnum.AI_UAV_Overview,
                                PermissionsEnum.AI_UAV_Batch_Image_Import,
                                PermissionsEnum.AI_UAV_Segmentation_List,
                                PermissionsEnum.AI_UAV_Job_Monitoring           
                              ],
                              $event
                          )
                      " />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="map-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.AI_UAV_Overview])"
                  (change)="onChangePermission([PermissionsEnum.AI_UAV_Overview], $event)">
                <label for="map-view" class="permission-label">{{ "SIDENAV.OVERVIEW" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="map-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.AI_UAV_Batch_Image_Import])"
                  (change)="onChangePermission([PermissionsEnum.AI_UAV_Batch_Image_Import], $event)">
                <label for="map-view" class="permission-label">{{ "SIDENAV.BATCH_IMAGE_IMPORT" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="map-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.AI_UAV_Segmentation_List])"
                  (change)="onChangePermission([PermissionsEnum.AI_UAV_Segmentation_List], $event)">
                <label for="map-view" class="permission-label">{{ "SIDENAV.SEGMENTATION_LIST" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="map-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.AI_UAV_Job_Monitoring])"
                  (change)="onChangePermission([PermissionsEnum.AI_UAV_Job_Monitoring], $event)">
                <label for="map-view" class="permission-label">{{ "SIDENAV.JOB_MONITORING" | translate }}</label>
              </div>
            </div>
          </div>
          <!-- MAP -->
          <div *ngIf="permissionsService.hasDashboardConfigMap"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="permission-header">
              <h3 class="permission-title">Map</h3>
              <label class="switch">
                <input type="checkbox" [checked]="
                          isChecked([
                              PermissionsEnum.Map_View
                          ])" (change)="
                          onChangePermission(
                              [
                                  PermissionsEnum.Map_View            
                              ],
                              $event
                          )
                      " />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="map-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Map_View])"
                  (change)="onChangePermission([PermissionsEnum.Map_View], $event)">
                <label for="map-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
              </div>
            </div>
          </div>
          <!-- CUSTOMERS -->
          <div *ngIf="permissionsService.hasDashboardConfigBuildings"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="permission-header">
              <h3 class="permission-title">Customers</h3>
              <label class="switch">
                <input type="checkbox" [checked]="
                          isChecked([
                              PermissionsEnum.Customer_View,
                              PermissionsEnum.Customer_CreateEdit,
                              PermissionsEnum.Customer_Delete,
                              PermissionsEnum.Customer_Unvisited,
                              PermissionsEnum.Customer_NewEntryBreakdown,
                              PermissionsEnum.Customer_Assign,
                              PermissionsEnum.Customer_ApproveReject,
                              PermissionsEnum.Customer_Review,
                              PermissionsEnum.Customer_AuditReview,
                              PermissionsEnum.Customer_RecallAssigned,
                              PermissionsEnum.Customer_RecallValidated,
                              PermissionsEnum.Customer_Retag,
                              PermissionsEnum.Customer_Regularization,
                              PermissionsEnum.Customer_Download,
                              PermissionsEnum.Customer_ElectricalAddressCode,
                              PermissionsEnum.Customer_PropertyCode,
                              PermissionsEnum.Customer_ValidationStatus,
                              PermissionsEnum.Customer_AuditStatus,
                              PermissionsEnum.Customer_ReviewStatus
                          ])" (change)="
                          onChangePermission([ 
                                PermissionsEnum.Customer_View,
                                PermissionsEnum.Customer_CreateEdit,
                                PermissionsEnum.Customer_Delete,
                                PermissionsEnum.Customer_Unvisited,
                                PermissionsEnum.Customer_NewEntryBreakdown,
                                PermissionsEnum.Customer_Assign,
                                PermissionsEnum.Customer_ApproveReject,
                                PermissionsEnum.Customer_Review,
                                PermissionsEnum.Customer_AuditReview,
                                PermissionsEnum.Customer_RecallAssigned,
                                PermissionsEnum.Customer_RecallValidated,
                                PermissionsEnum.Customer_Retag,
                                PermissionsEnum.Customer_Regularization,
                                PermissionsEnum.Customer_Download,
                                PermissionsEnum.Customer_Unvisited,
                                PermissionsEnum.Customer_ElectricalAddressCode,
                                PermissionsEnum.Customer_PropertyCode,
                                PermissionsEnum.Customer_ValidationStatus,
                                PermissionsEnum.Customer_AuditStatus,
                                PermissionsEnum.Customer_ReviewStatus
                              ],
                              $event
                          )
                      " />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="customer-view" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_View])"
                  (change)="onChangePermission([PermissionsEnum.Customer_View], $event)">
                <label for="customer-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-create-edit" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_CreateEdit])"
                  (change)="onChangePermission([PermissionsEnum.Customer_CreateEdit], $event)">
                <label for="customer-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                  }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-delete" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Delete])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Delete], $event)">
                <label for="customer-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-unvisited" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Unvisited])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Unvisited], $event)">
                <label for="customer-unvisited" class="permission-label">{{ "CUSTOMERS.UNVISITED" | translate }}</label>
              </div>
            </div>
            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="customer-new-entry-breakdown" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_NewEntryBreakdown])"
                  (change)="onChangePermission([PermissionsEnum.Customer_NewEntryBreakdown], $event)">
                <label for="customer-new-entry-breakdown" class="permission-label">{{
                  "ROLE_MANAGEMENT.NEW_ENTRY_BREAKDOWN" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-assign" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Assign])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Assign], $event)">
                <label for="customer-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-approve-reject" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_ApproveReject])"
                  (change)="onChangePermission([PermissionsEnum.Customer_ApproveReject], $event)">
                <label for="customer-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-review" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Review])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Review], $event)">
                <label for="customer-review" class="permission-label">{{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
              </div>
            </div>
            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="customer-audit-review" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_AuditReview])"
                  (change)="onChangePermission([PermissionsEnum.Customer_AuditReview], $event)">
                <label for="customer-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-recall-assigned" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_RecallAssigned])"
                  (change)="onChangePermission([PermissionsEnum.Customer_RecallAssigned], $event)">
                <label for="customer-recall-assigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-recall-validated" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_RecallValidated])"
                  (change)="onChangePermission([PermissionsEnum.Customer_RecallValidated], $event)">
                <label for="customer-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED" |
                  translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-retag" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Retag])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Retag], $event)">
                <label for="customer-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
              </div>
            </div>
            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="customer-regularization" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Regularization])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Regularization], $event)">
                <label for="customer-regularization" class="permission-label">{{ "COMMON.REGULARIZATION" | translate
                  }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-download" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_Download])"
                  (change)="onChangePermission([PermissionsEnum.Customer_Download], $event)">
                <label for="customer-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-electrical-address" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_ElectricalAddressCode])"
                  (change)="onChangePermission([PermissionsEnum.Customer_ElectricalAddressCode], $event)">
                <label for="customer-electrical-address" class="permission-label">{{
                  "COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS" | translate }}</label>
              </div>
              <div class="permission-item">
                <input type="checkbox" id="customer-property-code" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.Customer_PropertyCode])"
                  (change)="onChangePermission([PermissionsEnum.Customer_PropertyCode], $event)">
                <label for="customer-property-code" class="permission-label">{{ "COMMON.MBC_DETAILS.PROPERTY_CODE" |
                  translate }}</label>
              </div>
            </div>
            <!-- LIST PAGE -->
            <div class="d-flex flex-column gap-3 permission-container">
              <div class="permission-header">
                <h3 class="permission-title">List Page</h3>
              </div>

              <div class="permission-options">
                <div class="permission-item">
                  <input type="checkbox" id="customer-validation-status" class="custom-checkbox"
                    [checked]="isChecked([PermissionsEnum.Customer_ValidationStatus])"
                    (change)="onChangePermission([PermissionsEnum.Customer_ValidationStatus], $event)">
                  <label for="customer-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                    translate }}</label>
                </div>
                <div class="permission-item">
                  <input type="checkbox" id="customer-audit-status" class="custom-checkbox"
                    [checked]="isChecked([PermissionsEnum.Customer_AuditStatus])"
                    (change)="onChangePermission([PermissionsEnum.Customer_AuditStatus], $event)">
                  <label for="customer-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                    }}</label>
                </div>
                <div class="permission-item">
                  <input type="checkbox" id="customer-review-status" class="custom-checkbox"
                    [checked]="isChecked([PermissionsEnum.Customer_ReviewStatus])"
                    (change)="onChangePermission([PermissionsEnum.Customer_ReviewStatus], $event)">
                  <label for="customer-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                    }}</label>
                </div>

              </div>
            </div>
          </div>
          <!-- ASSETS -->
          <div [ngClass]="{ 'expanded-bg': assetsCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10" (click)="assetsCardExpanded = !assetsCardExpanded">Assets
              </h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="assetsCardExpanded = true" *ngIf="!assetsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="assetsCardExpanded = false" *ngIf="assetsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="assetsCardExpanded" class="permission-container gap-3 scrollable-information" @slideToggle>
              <!-- TRANSMISSION STATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigDTS">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'DASHBOARD.ASSET_BREAKDOWN.TRANSMISSION_STATIONS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Ts_View,
                                PermissionsEnum.Ts_CreateEdit,
                                PermissionsEnum.Ts_Delete,
                                PermissionsEnum.Ts_ValidationStatus,
                                PermissionsEnum.Ts_AuditStatus,
                                PermissionsEnum.Ts_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Ts_View,
                                  PermissionsEnum.Ts_CreateEdit,
                                  PermissionsEnum.Ts_Delete,
                                  PermissionsEnum.Ts_ValidationStatus,
                                  PermissionsEnum.Ts_AuditStatus,
                                  PermissionsEnum.Ts_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ts-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ts_View])"
                      (change)="onChangePermission([PermissionsEnum.Ts_View], $event)">
                    <label for="ts-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ts-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ts_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Ts_CreateEdit], $event)">
                    <label for="ts-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ts-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ts_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Ts_Delete], $event)">
                    <label for="ts-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
                <!-- LIST PAGE -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="ts-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ts_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ts_ValidationStatus], $event)">
                      <label for="ts-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="ts-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ts_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ts_AuditStatus], $event)">
                      <label for="ts-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="ts-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ts_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ts_ReviewStatus], $event)">
                      <label for="ts-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- INJECTION SUBSTATION -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'DASHBOARD.ASSET_BREAKDOWN.INJECTION_SUBSTATIONS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Ss_View,
                                PermissionsEnum.Ss_CreateEdit,
                                PermissionsEnum.Ss_Delete,
                                PermissionsEnum.Ss_ValidationStatus,
                                PermissionsEnum.Ss_AuditStatus,
                                PermissionsEnum.Ss_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                PermissionsEnum.Ss_View,
                                PermissionsEnum.Ss_CreateEdit,
                                PermissionsEnum.Ss_Delete,
                                PermissionsEnum.Ss_ValidationStatus,
                                PermissionsEnum.Ss_AuditStatus,
                                PermissionsEnum.Ss_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ss-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ss_View])"
                      (change)="onChangePermission([PermissionsEnum.Ss_View], $event)">
                    <label for="ss-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ss-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ss_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Ss_CreateEdit], $event)">
                    <label for="ss-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ss-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Ss_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Ss_Delete], $event)">
                    <label for="ss-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="ss-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ss_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ss_ValidationStatus], $event)">
                      <label for="ss-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="ss-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ss_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ss_AuditStatus], $event)">
                      <label for="ss-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="ss-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Ss_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Ss_ReviewStatus], $event)">
                      <label for="ss-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- DISTRIBUTION SUBSTATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigDTS">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'DASHBOARD.ASSET_BREAKDOWN.DISTRIBUTION_SUBSTATIONS' | translate }}
                  </h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Transformers_View,
                                PermissionsEnum.Transformers_CreateEdit,
                                PermissionsEnum.Transformers_CreateEditCrud,
                                PermissionsEnum.Transformers_ViewCrud,
                                PermissionsEnum.Transformers_Delete,
                                PermissionsEnum.Transformers_Assign,
                                PermissionsEnum.Transformers_ApproveReject,
                                PermissionsEnum.Transformers_AuditReview,
                                PermissionsEnum.Transformers_RecallAssigned,
                                PermissionsEnum.Transformers_RecallValidated,
                                PermissionsEnum.Transformers_Retag,
                                PermissionsEnum.Transformers_Download,
                                PermissionsEnum.Transformers_ValidationStatus,
                                PermissionsEnum.Transformers_AuditStatus,
                                PermissionsEnum.Transformers_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Transformers_View,
                                  PermissionsEnum.Transformers_CreateEdit,
                                  PermissionsEnum.Transformers_CreateEditCrud,
                                  PermissionsEnum.Transformers_ViewCrud,
                                  PermissionsEnum.Transformers_Delete,
                                  PermissionsEnum.Transformers_Assign,
                                  PermissionsEnum.Transformers_ApproveReject,
                                  PermissionsEnum.Transformers_AuditReview,
                                  PermissionsEnum.Transformers_RecallAssigned,
                                  PermissionsEnum.Transformers_RecallValidated,
                                  PermissionsEnum.Transformers_Retag,
                                  PermissionsEnum.Transformers_Download,
                                  PermissionsEnum.Transformers_ValidationStatus,
                                  PermissionsEnum.Transformers_AuditStatus,
                                  PermissionsEnum.Transformers_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_View])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_View], $event)">
                    <label for="dt-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_ViewCrud])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_ViewCrud], $event)">
                    <label for="dt-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }} {{
                      "ROLE_MANAGEMENT.CRUD" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_CreateEdit], $event)">
                    <label for="dt-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-create-edit-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_CreateEditCrud])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_CreateEditCrud], $event)">
                    <label for="dt-create-edit-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }} {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_Delete], $event)">
                    <label for="dt-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_Assign])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_Assign], $event)">
                    <label for="dt-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_ApproveReject], $event)">
                    <label for="dt-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_AuditReview], $event)">
                    <label for="dt-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate
                      }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item"
                    *ngIf="EMCConfig_DS.includes(EntityModelConfiguration.RecallAssignedTask)">
                    <input type="checkbox" id="dt-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_RecallAssigned], $event)">
                    <label for="dt-recall-asigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item"
                    *ngIf="EMCConfig_DS.includes(EntityModelConfiguration.RecallValidatedTask)">
                    <input type="checkbox" id="dt-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_RecallValidated], $event)">
                    <label for="dt-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item" *ngIf="EMCConfig_DS.includes(EntityModelConfiguration.Retag)">
                    <input type="checkbox" id="dt-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_Retag], $event)">
                    <label for="dt-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_Download])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_Download], $event)">
                    <label for="dt-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="dt-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Transformers_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Transformers_ValidationStatus], $event)">
                      <label for="dt-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="dt-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Transformers_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Transformers_AuditStatus], $event)">
                      <label for="dt-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="dt-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Transformers_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Transformers_ReviewStatus], $event)">
                      <label for="dt-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- RMUs -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigRmus">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'RMU.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Rmus_View,
                                PermissionsEnum.Rmus_ViewCrud,
                                PermissionsEnum.Rmus_CreateEdit,
                                PermissionsEnum.Rmus_CreateEditCrud,
                                PermissionsEnum.Rmus_Delete,
                                PermissionsEnum.Rmus_Assign,
                                PermissionsEnum.Rmus_ApproveReject,
                                PermissionsEnum.Rmus_AuditReview,
                                PermissionsEnum.Rmus_RecallAssigned,
                                PermissionsEnum.Rmus_RecallValidated,
                                PermissionsEnum.Rmus_Retag,
                                PermissionsEnum.Rmus_Download,
                                PermissionsEnum.Rmus_ValidationStatus,
                                PermissionsEnum.Rmus_AuditStatus,
                                PermissionsEnum.Rmus_ReviewStatus,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Rmus_View,
                                  PermissionsEnum.Rmus_ViewCrud,
                                  PermissionsEnum.Rmus_CreateEdit,
                                  PermissionsEnum.Rmus_CreateEditCrud,
                                  PermissionsEnum.Rmus_Delete,
                                  PermissionsEnum.Rmus_Assign,
                                  PermissionsEnum.Rmus_ApproveReject,
                                  PermissionsEnum.Rmus_AuditReview,
                                  PermissionsEnum.Rmus_RecallAssigned,
                                  PermissionsEnum.Rmus_RecallValidated,
                                  PermissionsEnum.Rmus_Retag,
                                  PermissionsEnum.Rmus_Download,
                                  PermissionsEnum.Rmus_ValidationStatus,
                                  PermissionsEnum.Rmus_AuditStatus,
                                  PermissionsEnum.Rmus_ReviewStatus,
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_View])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_View], $event)">
                    <label for="rmu-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_ViewCrud])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_ViewCrud], $event)">
                    <label for="rmu-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }} {{
                      "ROLE_MANAGEMENT.CRUD" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_CreateEdit], $event)">
                    <label for="rmu-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-create-edit-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_CreateEditCrud])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_CreateEditCrud], $event)">
                    <label for="rmu-create-edit-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }} {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_Delete], $event)">
                    <label for="rmu-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_Assign])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_Assign], $event)">
                    <label for="rmu-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_ApproveReject], $event)">
                    <label for="rmu-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_AuditReview], $event)">
                    <label for="rmu-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate
                      }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-recall-assigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_RecallAssigned], $event)">
                    <label for="rmu-recall-assigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_RecallValidated], $event)">
                    <label for="rmu-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_Retag], $event)">
                    <label for="rmu-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_Download])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_Download], $event)">
                    <label for="rmu-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="rmu-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Rmus_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Rmus_ValidationStatus], $event)">
                      <label for="rmu-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="rmu-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Rmus_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Rmus_AuditStatus], $event)">
                      <label for="rmu-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="rmu-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Rmus_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Rmus_ReviewStatus], $event)">
                      <label for="rmu-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- MAIN FEEDERS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigFeeders">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MAIN_FEEDERS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.F33_View,
                                PermissionsEnum.F33_CreateEdit,
                                PermissionsEnum.F33_Delete,
                                PermissionsEnum.F33_ValidationStatus,
                                PermissionsEnum.F33_AuditStatus,
                                PermissionsEnum.F33_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.F33_View,
                                  PermissionsEnum.F33_CreateEdit,
                                  PermissionsEnum.F33_Delete,
                                  PermissionsEnum.F33_ValidationStatus,
                                  PermissionsEnum.F33_AuditStatus,
                                  PermissionsEnum.F33_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="f33-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F33_View])"
                      (change)="onChangePermission([PermissionsEnum.F33_View], $event)">
                    <label for="f33-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="f33-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F33_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.F33_CreateEdit], $event)">
                    <label for="f33-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="f33-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F33_Delete])"
                      (change)="onChangePermission([PermissionsEnum.F33_Delete], $event)">
                    <label for="f33-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="f33-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F33_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.F33_ValidationStatus], $event)">
                      <label for="f33-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="f33-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F33_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.F33_AuditStatus], $event)">
                      <label for="f33-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="f33-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F33_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.F33_ReviewStatus], $event)">
                      <label for="f33-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- SUB FEEDERS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigFeeders">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.SECONDARY_FEEDERS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.F11_View,
                                PermissionsEnum.F11_CreateEdit,
                                PermissionsEnum.F11_Delete,
                                PermissionsEnum.F11_ValidationStatus,
                                PermissionsEnum.F11_AuditStatus,
                                PermissionsEnum.F11_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.F11_View,
                                  PermissionsEnum.F11_CreateEdit,
                                  PermissionsEnum.F11_Delete,
                                  PermissionsEnum.F11_ValidationStatus,
                                  PermissionsEnum.F11_AuditStatus,
                                  PermissionsEnum.F11_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="f11-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F11_View])"
                      (change)="onChangePermission([PermissionsEnum.F11_View], $event)">
                    <label for="f11-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="f11-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F11_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.F11_CreateEdit], $event)">
                    <label for="f11-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="f11-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.F11_Delete])"
                      (change)="onChangePermission([PermissionsEnum.F11_Delete], $event)">
                    <label for="f11-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="f11-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F11_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.F11_ValidationStatus], $event)">
                      <label for="f11-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="f11-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F11_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.F11_AuditStatus], $event)">
                      <label for="f11-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="f11-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.F11_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.F11_ReviewStatus], $event)">
                      <label for="f11-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- HV POLES -->
              <div class="sub-group-container" *ngIf="!currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.HV_POLES' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.HVPole_View,
                                PermissionsEnum.HVPole_CreateEdit,
                                PermissionsEnum.HVPole_Delete,
                                PermissionsEnum.HVPole_Assign,
                                PermissionsEnum.HVPole_ApproveReject,
                                PermissionsEnum.HVPole_AuditReview,
                                PermissionsEnum.HVPole_RecallAssigned,
                                PermissionsEnum.HVPole_Retag,
                                PermissionsEnum.HVPole_RecallValidated,
                                PermissionsEnum.HVPole_Download,
                                PermissionsEnum.HVPole_ValidationStatus,
                                PermissionsEnum.HVPole_AuditStatus,
                                PermissionsEnum.HVPole_ReviewStatus,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.HVPole_View,
                                  PermissionsEnum.HVPole_CreateEdit,
                                  PermissionsEnum.HVPole_Delete,
                                  PermissionsEnum.HVPole_Assign,
                                  PermissionsEnum.HVPole_ApproveReject,
                                  PermissionsEnum.HVPole_AuditReview,
                                  PermissionsEnum.HVPole_RecallAssigned,
                                  PermissionsEnum.HVPole_Retag,
                                  PermissionsEnum.HVPole_RecallValidated,
                                  PermissionsEnum.HVPole_Download,
                                  PermissionsEnum.HVPole_ValidationStatus,
                                  PermissionsEnum.HVPole_AuditStatus,
                                  PermissionsEnum.HVPole_ReviewStatus,
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_View])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_View], $event)">
                    <label for="hv-pole-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_CreateEdit], $event)">
                    <label for="hv-pole-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_Delete])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_Delete], $event)">
                    <label for="hv-pole-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_Assign])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_Assign], $event)">
                    <label for="hv-pole-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate
                      }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_ApproveReject], $event)">
                    <label for="hv-pole-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_AuditReview], $event)">
                    <label for="hv-pole-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_RecallAssigned], $event)">
                    <label for="hv-pole-recall-asigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_RecallValidated], $event)">
                    <label for="hv-pole-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED"
                      | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_Retag])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_Retag], $event)">
                    <label for="hv-pole-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="hv-pole-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.HVPole_Download])"
                      (change)="onChangePermission([PermissionsEnum.HVPole_Download], $event)">
                    <label for="hv-pole-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="hv-pole-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.HVPole_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.HVPole_ValidationStatus], $event)">
                      <label for="hv-pole-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="hv-pole-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.HVPole_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.HVPole_AuditStatus], $event)">
                      <label for="hv-pole-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="hv-pole-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.HVPole_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.HVPole_ReviewStatus], $event)">
                      <label for="hv-pole-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- MV POLES -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigMVPoles && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.MV_POLES' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.MVPole_View,
                                PermissionsEnum.MVPole_CreateEdit,
                                PermissionsEnum.MVPole_Delete,
                                PermissionsEnum.MVPole_Assign,
                                PermissionsEnum.MVPole_ApproveReject,
                                PermissionsEnum.MVPole_AuditReview,
                                PermissionsEnum.MVPole_RecallAssigned,
                                PermissionsEnum.MVPole_Retag,
                                PermissionsEnum.MVPole_RecallValidated,
                                PermissionsEnum.MVPole_Download,
                                PermissionsEnum.MVPole_ValidationStatus,
                                PermissionsEnum.MVPole_AuditStatus,
                                PermissionsEnum.MVPole_ReviewStatus,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.MVPole_View,
                                  PermissionsEnum.MVPole_CreateEdit,
                                  PermissionsEnum.MVPole_Delete,
                                  PermissionsEnum.MVPole_Assign,
                                  PermissionsEnum.MVPole_ApproveReject,
                                  PermissionsEnum.MVPole_AuditReview,
                                  PermissionsEnum.MVPole_RecallAssigned,
                                  PermissionsEnum.MVPole_Retag,
                                  PermissionsEnum.MVPole_RecallValidated,
                                  PermissionsEnum.MVPole_Download,
                                  PermissionsEnum.MVPole_ValidationStatus,
                                  PermissionsEnum.MVPole_AuditStatus,
                                  PermissionsEnum.MVPole_ReviewStatus,
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_View])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_View], $event)">
                    <label for="mv-pole-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_CreateEdit], $event)">
                    <label for="mv-pole-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Delete])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Delete], $event)">
                    <label for="mv-pole-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Assign])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Assign], $event)">
                    <label for="mv-pole-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate
                      }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_ApproveReject], $event)">
                    <label for="mv-pole-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_AuditReview], $event)">
                    <label for="mv-pole-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item"
                    *ngIf="EMCConfig_MvPole.includes(EntityModelConfiguration.RecallAssignedTask)">
                    <input type="checkbox" id="mv-pole-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_RecallAssigned], $event)">
                    <label for="mv-pole-recall-asigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item"
                    *ngIf="EMCConfig_MvPole.includes(EntityModelConfiguration.RecallValidatedTask)">
                    <input type="checkbox" id="mv-pole-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_RecallValidated], $event)">
                    <label for="mv-pole-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED"
                      | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item" *ngIf="EMCConfig_MvPole.includes(EntityModelConfiguration.Retag)">
                    <input type="checkbox" id="mv-pole-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Retag])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Retag], $event)">
                    <label for="mv-pole-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Download])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Download], $event)">
                    <label for="mv-pole-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="mv-pole-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.MVPole_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.MVPole_ValidationStatus], $event)">
                      <label for="mv-pole-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="mv-pole-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.MVPole_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.MVPole_AuditStatus], $event)">
                      <label for="mv-pole-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="mv-pole-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.MVPole_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.MVPole_ReviewStatus], $event)">
                      <label for="mv-pole-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- LV POLES -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigPoles && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.LV_POLES' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Pole_View,
                                PermissionsEnum.Pole_CreateEdit,
                                PermissionsEnum.Pole_Delete,
                                PermissionsEnum.Pole_Assign,
                                PermissionsEnum.Pole_ApproveReject,
                                PermissionsEnum.Pole_AuditReview,
                                PermissionsEnum.Pole_RecallAssigned,
                                PermissionsEnum.Pole_Retag,
                                PermissionsEnum.Pole_RecallValidated,
                                PermissionsEnum.Pole_Download,
                                PermissionsEnum.Pole_ValidationStatus,
                                PermissionsEnum.Pole_AuditStatus,
                                PermissionsEnum.Pole_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Pole_View,
                                  PermissionsEnum.Pole_CreateEdit,
                                  PermissionsEnum.Pole_Delete,
                                  PermissionsEnum.Pole_Assign,
                                  PermissionsEnum.Pole_ApproveReject,
                                  PermissionsEnum.Pole_AuditReview,
                                  PermissionsEnum.Pole_RecallAssigned,
                                  PermissionsEnum.Pole_Retag,
                                  PermissionsEnum.Pole_RecallValidated,
                                  PermissionsEnum.Pole_Download,
                                  PermissionsEnum.Pole_ValidationStatus,
                                  PermissionsEnum.Pole_AuditStatus,
                                  PermissionsEnum.Pole_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="pole-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_View])"
                      (change)="onChangePermission([PermissionsEnum.Pole_View], $event)">
                    <label for="pole-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Pole_CreateEdit], $event)">
                    <label for="pole-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Delete], $event)">
                    <label for="pole-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Assign])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Assign], $event)">
                    <label for="pole-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="pole-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Pole_ApproveReject], $event)">
                    <label for="pole-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.Pole_AuditReview], $event)">
                    <label for="pole-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item"
                    *ngIf="EMCConfig_LvPole.includes(EntityModelConfiguration.RecallAssignedTask)">
                    <input type="checkbox" id="pole-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.Pole_RecallAssigned], $event)">
                    <label for="pole-recall-asigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item"
                    *ngIf="EMCConfig_LvPole.includes(EntityModelConfiguration.RecallValidatedTask)">
                    <input type="checkbox" id="pole-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.Pole_RecallValidated], $event)">
                    <label for="pole-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED" |
                      translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item" *ngIf="EMCConfig_LvPole.includes(EntityModelConfiguration.Retag)">
                    <input type="checkbox" id="pole-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Retag], $event)">
                    <label for="pole-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Download])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Download], $event)">
                    <label for="pole-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="pole-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Pole_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Pole_ValidationStatus], $event)">
                      <label for="pole-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="pole-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Pole_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Pole_AuditStatus], $event)">
                      <label for="pole-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="pole-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Pole_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Pole_ReviewStatus], $event)">
                      <label for="pole-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- BUILDINGS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigBuildings">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.BUILDING.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Building_View,
                                PermissionsEnum.Building_CreateEdit,
                                PermissionsEnum.Building_Delete,
                                PermissionsEnum.Building_Assign,
                                PermissionsEnum.Building_ApproveReject,
                                PermissionsEnum.Building_AuditReview,
                                PermissionsEnum.Building_RecallAssigned,
                                PermissionsEnum.Building_RecallValidated,
                                PermissionsEnum.Building_Retag,
                                PermissionsEnum.Building_Download,
                                PermissionsEnum.Building_Review,
                                PermissionsEnum.Building_ElectricalAddressCode,
                                PermissionsEnum.Building_PropertyCode,
                                PermissionsEnum.Building_ValidationStatus,
                                PermissionsEnum.Building_AuditStatus,
                                PermissionsEnum.Building_ReviewStatus,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Building_View,
                                  PermissionsEnum.Building_CreateEdit,
                                  PermissionsEnum.Building_Delete,
                                  PermissionsEnum.Building_Assign,
                                  PermissionsEnum.Building_ApproveReject,
                                  PermissionsEnum.Building_AuditReview,
                                  PermissionsEnum.Building_RecallAssigned,
                                  PermissionsEnum.Building_RecallValidated,
                                  PermissionsEnum.Building_Retag,
                                  PermissionsEnum.Building_Download,
                                  PermissionsEnum.Building_Review,
                                  PermissionsEnum.Building_ElectricalAddressCode,
                                  PermissionsEnum.Building_PropertyCode,
                                  PermissionsEnum.Building_ValidationStatus,
                                  PermissionsEnum.Building_AuditStatus,
                                  PermissionsEnum.Building_ReviewStatus,
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="building-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_View])"
                      (change)="onChangePermission([PermissionsEnum.Building_View], $event)">
                    <label for="building-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Building_CreateEdit], $event)">
                    <label for="building-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Building_Delete], $event)">
                    <label for="building-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Assign])"
                      (change)="onChangePermission([PermissionsEnum.Building_Assign], $event)">
                    <label for="building-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate
                      }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="building-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Building_ApproveReject], $event)">
                    <label for="building-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.Building_AuditReview], $event)">
                    <label for="building-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.Building_RecallAssigned], $event)">
                    <label for="building-recall-asigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.Building_RecallValidated], $event)">
                    <label for="building-recall-validated" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="building-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Building_Retag], $event)">
                    <label for="building-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Download])"
                      (change)="onChangePermission([PermissionsEnum.Building_Download], $event)">
                    <label for="building-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-electrical-address" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_ElectricalAddressCode])"
                      (change)="onChangePermission([PermissionsEnum.Building_ElectricalAddressCode], $event)">
                    <label for="building-electrical-address" class="permission-label">{{
                      "COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-propery-code" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_PropertyCode])"
                      (change)="onChangePermission([PermissionsEnum.Building_PropertyCode], $event)">
                    <label for="building-propery-code" class="permission-label">{{ "COMMON.MBC_DETAILS.PROPERTY_CODE" |
                      translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="building-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Building_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Building_ValidationStatus], $event)">
                      <label for="building-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="building-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Building_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Building_AuditStatus], $event)">
                      <label for="building-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="building-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Building_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Building_ReviewStatus], $event)">
                      <label for="building-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <!-- METERS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigBuildings">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'METERS.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Meters_View,
                                PermissionsEnum.Meters_CreateEdit,
                                PermissionsEnum.Meters_Delete,
                                PermissionsEnum.Meters_ApproveReject,
                                PermissionsEnum.Meters_Retag,
                                PermissionsEnum.Meters_Download,
                                PermissionsEnum.Meters_ValidationStatus,
                                PermissionsEnum.Meters_AuditStatus,
                                PermissionsEnum.Meters_ReviewStatus
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Meters_View,
                                  PermissionsEnum.Meters_CreateEdit,
                                  PermissionsEnum.Meters_Delete,
                                  PermissionsEnum.Meters_ApproveReject,
                                  PermissionsEnum.Meters_Retag,
                                  PermissionsEnum.Meters_Download,
                                  PermissionsEnum.Meters_ValidationStatus,
                                  PermissionsEnum.Meters_AuditStatus,
                                  PermissionsEnum.Meters_ReviewStatus
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_View])"
                      (change)="onChangePermission([PermissionsEnum.Meters_View], $event)">
                    <label for="meter-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-view-crud" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Meters_CreateEdit], $event)">
                    <label for="meter-view-crud" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Meters_Delete], $event)">
                    <label for="meter-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Meters_ApproveReject], $event)">
                    <label for="meter-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Meters_Retag], $event)">
                    <label for="meter-approve-reject" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_Download])"
                      (change)="onChangePermission([PermissionsEnum.Meters_Download], $event)">
                    <label for="meter-audit-review" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
                <!-- List Page -->
                <div class="d-flex flex-column gap-3 permission-container">
                  <div class="permission-header">
                    <h3 class="permission-title">List Page</h3>
                  </div>

                  <div class="permission-options">
                    <div class="permission-item">
                      <input type="checkbox" id="meter-validation-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Meters_ValidationStatus])"
                        (change)="onChangePermission([PermissionsEnum.Meters_ValidationStatus], $event)">
                      <label for="meter-validation-status" class="permission-label">{{ "COMMON.VALIDATION_STATUS" |
                        translate }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="meter-audit-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Meters_AuditStatus])"
                        (change)="onChangePermission([PermissionsEnum.Meters_AuditStatus], $event)">
                      <label for="meter-audit-status" class="permission-label">{{ "COMMON.AUDIT_STATUS" | translate
                        }}</label>
                    </div>
                    <div class="permission-item">
                      <input type="checkbox" id="meter-review-status" class="custom-checkbox"
                        [checked]="isChecked([PermissionsEnum.Meters_ReviewStatus])"
                        (change)="onChangePermission([PermissionsEnum.Meters_ReviewStatus], $event)">
                      <label for="meter-review-status" class="permission-label">{{ "COMMON.REVIEW_STATUS" | translate
                        }}</label>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- OPERATIONS -->
          <div [ngClass]="{ 'expanded-bg': operationsCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10" (click)="operationsCardExpanded = !operationsCardExpanded">
                Operations</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="operationsCardExpanded = true" *ngIf="!operationsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="operationsCardExpanded = false" *ngIf="operationsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="operationsCardExpanded" class="permission-container gap-3 scrollable-information" @slideToggle>
              <!-- SERVICE REQUEST -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigNewService">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'HEADER_TITLE.SERVICE_REQUEST' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.NewService_View,
                                PermissionsEnum.NewService_CreateEdit,
                                PermissionsEnum.NewService_Download,
                                PermissionsEnum.NewService_BulkUpload,
                                PermissionsEnum.NewService_ApproveReject,
                                PermissionsEnum.NewService_RecallValidated,
                                PermissionsEnum.NewService_HighCapacity,
                                PermissionsEnum.NewService_StandardCapacity
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.NewService_View,
                                  PermissionsEnum.NewService_CreateEdit,
                                  PermissionsEnum.NewService_Download,
                                  PermissionsEnum.NewService_BulkUpload,
                                  PermissionsEnum.NewService_ApproveReject,
                                  PermissionsEnum.NewService_RecallValidated,
                                  PermissionsEnum.NewService_HighCapacity,
                                  PermissionsEnum.NewService_StandardCapacity
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_View])"
                      (change)="onChangePermission([PermissionsEnum.NewService_View], $event)">
                    <label for="new-service-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.NewService_CreateEdit], $event)">
                    <label for="new-service-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_Download])"
                      (change)="onChangePermission([PermissionsEnum.NewService_Download], $event)">
                    <label for="new-service-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-bulk-upload" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_BulkUpload])"
                      (change)="onChangePermission([PermissionsEnum.NewService_BulkUpload], $event)">
                    <label for="new-service-bulk-upload" class="permission-label">{{
                      "ROLE_MANAGEMENT.SERVICE_REQUEST_BULK_UPLOAD" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.NewService_ApproveReject], $event)">
                    <label for="new-service-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.VALIDATION" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.NewService_RecallValidated], $event)">
                    <label for="new-service-recall-validated" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-high-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_HighCapacity])"
                      (change)="onChangePermission([PermissionsEnum.NewService_HighCapacity], $event)">
                    <label for="new-service-high-capacity" class="permission-label">{{ 'ROLE_MANAGEMENT.HIGH_CAPACITY' |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="new-service-standard-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NewService_StandardCapacity])"
                      (change)="onChangePermission([PermissionsEnum.NewService_StandardCapacity], $event)">
                    <label for="new-service-standard-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- SITE VERIFICATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigNewService">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.SITE_VERIFICATION' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.SiteVerification_View,
                                PermissionsEnum.SiteVerification_CreateEdit,
                                PermissionsEnum.SiteVerification_Download,
                                PermissionsEnum.SiteVerification_Validation,
                                PermissionsEnum.SiteVerification_RecallAssigned,
                                PermissionsEnum.SiteVerification_RecallValidated,
                                PermissionsEnum.SiteVerification_SiteVerification,
                                PermissionsEnum.SiteVerification_HighCapacity,
                                PermissionsEnum.SiteVerification_StandardCapacity
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.SiteVerification_View,
                                  PermissionsEnum.SiteVerification_CreateEdit,
                                  PermissionsEnum.SiteVerification_Download,
                                  PermissionsEnum.SiteVerification_Validation,
                                  PermissionsEnum.SiteVerification_RecallAssigned,
                                  PermissionsEnum.SiteVerification_RecallValidated,
                                  PermissionsEnum.SiteVerification_SiteVerification,
                                  PermissionsEnum.SiteVerification_HighCapacity,
                                  PermissionsEnum.SiteVerification_StandardCapacity
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_View])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_View], $event)">
                    <label for="site-verification-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_CreateEdit], $event)">
                    <label for="site-verification-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT"
                      | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_Download])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_Download], $event)">
                    <label for="site-verification-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-validation" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_Validation])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_Validation], $event)">
                    <label for="site-verification-validation" class="permission-label">{{ "ROLE_MANAGEMENT.VALIDATION" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-recall-assigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_RecallAssigned], $event)">
                    <label for="site-verification-recall-assigned" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_RecallValidated], $event)">
                    <label for="site-verification-recall-validated" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-site-verification" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_SiteVerification])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_SiteVerification], $event)">
                    <label for="site-verification-site-verification" class="permission-label">{{
                      "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-high-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_HighCapacity])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_HighCapacity], $event)">
                    <label for="site-verification-high-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="site-verification-standard-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_StandardCapacity])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_StandardCapacity], $event)">
                    <label for="site-verification-standard-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- SERVICE REQUEST AUTHORIZATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigNewService">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.SERVICE_CONNECTION_CHARGES' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.ServiceRequestAuth_View,
                                PermissionsEnum.ServiceRequestAuth_CreateEdit,
                                PermissionsEnum.ServiceRequestAuth_Download,
                                PermissionsEnum.ServiceRequestAuth_BulkUpload,
                                PermissionsEnum.ServiceRequestAuth_Validation,
                                PermissionsEnum.ServiceRequestAuth_HighCapacity,
                                PermissionsEnum.ServiceRequestAuth_StandardCapacity
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.ServiceRequestAuth_View,
                                  PermissionsEnum.ServiceRequestAuth_CreateEdit,
                                  PermissionsEnum.ServiceRequestAuth_Download,
                                  PermissionsEnum.ServiceRequestAuth_BulkUpload,
                                  PermissionsEnum.ServiceRequestAuth_Validation,
                                  PermissionsEnum.ServiceRequestAuth_HighCapacity,
                                  PermissionsEnum.ServiceRequestAuth_StandardCapacity
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_View])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_View], $event)">
                    <label for="service-request-auth-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_CreateEdit], $event)">
                    <label for="service-request-auth-create-edit" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_Download])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_Download], $event)">
                    <label for="service-request-auth-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-bulk-upload" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_BulkUpload])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_BulkUpload], $event)">
                    <label for="service-request-auth-bulk-upload" class="permission-label">{{
                      "ROLE_MANAGEMENT.SERVICE_REQUEST_AUTH_BULK_UPLOAD" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-validation" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_Validation])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_Validation], $event)">
                    <label for="service-request-auth-validation" class="permission-label">{{
                      "ROLE_MANAGEMENT.VALIDATION" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-high-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_HighCapacity])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_HighCapacity], $event)">
                    <label for="service-request-auth-high-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="service-request-auth-standard-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_StandardCapacity])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestAuth_StandardCapacity], $event)">
                    <label for="service-request-auth-standard-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- ONBOARDED CUSTOMERS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigNewService">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'HEADER_TITLE.ONBOARDED_CUSTOMERS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.OnboardedCustomers_View,
                                PermissionsEnum.OnboardedCustomers_CreateEdit,
                                PermissionsEnum.OnboardedCustomers_Download,
                                PermissionsEnum.OnboardedCustomers_AssignToVendor,
                                PermissionsEnum.OnboardedCustomers_HighCapacity,
                                PermissionsEnum.OnboardedCustomers_StandardCapacity
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.OnboardedCustomers_View,
                                  PermissionsEnum.OnboardedCustomers_CreateEdit,
                                  PermissionsEnum.OnboardedCustomers_Download,
                                  PermissionsEnum.OnboardedCustomers_AssignToVendor,
                                  PermissionsEnum.OnboardedCustomers_HighCapacity,
                                  PermissionsEnum.OnboardedCustomers_StandardCapacity
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_View])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_View], $event)">
                    <label for="onboarded-customers-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_CreateEdit], $event)">
                    <label for="onboarded-customers-create-edit" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_Download])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_Download], $event)">
                    <label for="onboarded-customers-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-assign-to-vendor" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_AssignToVendor])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_AssignToVendor], $event)">
                    <label for="onboarded-customers-assign-to-vendor" class="permission-label">{{
                      "ROLE_MANAGEMENT.ASSIGN_TO_VENDOR" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-high-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_HighCapacity])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_HighCapacity], $event)">
                    <label for="onboarded-customers-high-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="onboarded-customers-standard-capacity" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.OnboardedCustomers_StandardCapacity])"
                      (change)="onChangePermission([PermissionsEnum.OnboardedCustomers_StandardCapacity], $event)">
                    <label for="onboarded-customers-standard-capacity" class="permission-label">{{
                      'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- SERVICE REQUEST TRACKER -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigNewService">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'HEADER_TITLE.SERVICE_REQUEST_TRACKER' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.ServiceRequestTracker_View
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.ServiceRequestTracker_View
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="service-req-tracker-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ServiceRequestTracker_View])"
                      (change)="onChangePermission([PermissionsEnum.ServiceRequestTracker_View], $event)">
                    <label for="service-req-tracker-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                </div>
              </div>

              <!-- SURVEY -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigSurvey">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.Survey_View,
                                  PermissionsEnum.Survey_CreateEdit,
                                  PermissionsEnum.Survey_Delete,
                                  PermissionsEnum.Survey_ApproveReject,
                                  PermissionsEnum.Survey_RecallApproved,
                                  PermissionsEnum.Survey_RecallRejected,
                                  PermissionsEnum.Survey_AssignMapVendor,
                                  PermissionsEnum.Survey_AssignToVendor
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Survey_View,
                                  PermissionsEnum.Survey_CreateEdit,
                                  PermissionsEnum.Survey_Delete,
                                  PermissionsEnum.Survey_ApproveReject,
                                  PermissionsEnum.Survey_RecallApproved,
                                  PermissionsEnum.Survey_RecallRejected,
                                  PermissionsEnum.Survey_AssignMapVendor,
                                  PermissionsEnum.Survey_AssignToVendor
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="survey-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_View])"
                      (change)="onChangePermission([PermissionsEnum.Survey_View], $event)">
                    <label for="survey-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Survey_CreateEdit], $event)">
                    <label for="survey-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Survey_Delete], $event)">
                    <label for="survey-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Survey_ApproveReject], $event)">
                    <label for="survey-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-recall-approved" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_RecallApproved])"
                      (change)="onChangePermission([PermissionsEnum.Survey_RecallApproved], $event)">
                    <label for="survey-recall-approved" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_APPROVED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-recall-rejected" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_RecallRejected])"
                      (change)="onChangePermission([PermissionsEnum.Survey_RecallRejected], $event)">
                    <label for="survey-recall-rejected" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_REJECTED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-assign-map-vendor" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_AssignMapVendor])"
                      (change)="onChangePermission([PermissionsEnum.Survey_AssignMapVendor], $event)">
                    <label for="survey-assign-map-vendor" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN_MAP_VENDOR" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-assign-to-vendor" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_AssignToVendor])"
                      (change)="onChangePermission([PermissionsEnum.Survey_AssignToVendor], $event)">
                    <label for="survey-assign-to-vendor" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN_TO_VENDOR" |
                      translate }}</label>
                  </div>
                </div>
              </div>

              <!-- CUSTOMER INSTALLATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigInstallation">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.CUSTOMER_INSTALLATION' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Installation_View,
                                PermissionsEnum.Installation_CreateEdit,
                                PermissionsEnum.Installation_Delete,
                                PermissionsEnum.Installation_ApproveReject
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Installation_View,
                                  PermissionsEnum.Installation_CreateEdit,
                                  PermissionsEnum.Installation_Delete,
                                  PermissionsEnum.Installation_ApproveReject
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="installation-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_View])"
                      (change)="onChangePermission([PermissionsEnum.Installation_View], $event)">
                    <label for="installation-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="installation-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Installation_CreateEdit], $event)">
                    <label for="installation-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="installation-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Installation_Delete], $event)">
                    <label for="installation-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="installation-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Installation_ApproveReject], $event)">
                    <label for="installation-approve-reject" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- DT METER INSTALLATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigDtMeterInstallation">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.DT_METER_INSTALLATION' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked(dtMeterInstallationPermissions)" (change)="
                              onChangePermission(dtMeterInstallationPermissions, $event)
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_View])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_View], $event)">
                    <label for="dt-meter-installation-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_CreateEdit], $event)">
                    <label for="dt-meter-installation-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_Delete])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_Delete], $event)">
                    <label for="dt-meter-installation-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ApproveReject], $event)">
                    <label for="dt-meter-installation-approve-reject" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-recall" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_Recall])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_Recall], $event)">
                    <label for="dt-meter-installation-recall" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-authorize-metering" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AuthorizeMetering])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_AuthorizeMetering], $event)">
                    <label for="dt-meter-installation-authorize-metering" class="permission-label">{{
                      "ROLE_MANAGEMENT.AUTHORIZE_METERING" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-vendor-assignment" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_VendorAssignment])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_VendorAssignment], $event)">
                    <label for="dt-meter-installation-vendor-assignment" class="permission-label">{{
                      "ROLE_MANAGEMENT.VENDOR_ASSIGNMENT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-decline-report" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_DeclineReport])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_DeclineReport], $event)">
                    <label for="dt-meter-installation-decline-report" class="permission-label">{{
                      "ROLE_MANAGEMENT.DECLINE_REPORT" | translate }}</label>
                  </div>
                </div>

                <div class="permission-options" *ngIf="permissionsService.hasDashboardConfigMeterApprovalAndRepayment">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-accept-decline" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AcceptDecline])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_AcceptDecline], $event)">
                    <label for="dt-meter-installation-accept-decline" class="permission-label">{{
                      "ROLE_MANAGEMENT.ACCEPT_AND_DECLINE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-approve-meter" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveMeter])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ApproveMeter], $event)">
                    <label for="dt-meter-installation-approve-meter" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_METER" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-approve-invoice" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveInvoice])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ApproveInvoice], $event)">
                    <label for="dt-meter-installation-approve-invoice" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_INVOICE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-recall-awaiting-approval" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval], $event)">
                    <label for="dt-meter-installation-recall-awaiting-approval" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_AWAITING_APPROVAL" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-acknowledge-repayment" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment], $event)">
                    <label for="dt-meter-installation-acknowledge-repayment" class="permission-label">{{
                      "ROLE_MANAGEMENT.ACKNOWLEDGE_REPAYMENT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-view-meter-approval" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewMeterApproval])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ViewMeterApproval], $event)">
                    <label for="dt-meter-installation-view-meter-approval" class="permission-label">{{
                      "ROLE_MANAGEMENT.VIEW_METER_APPROVAL" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-view-invoice-approval" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval], $event)">
                    <label for="dt-meter-installation-view-invoice-approval" class="permission-label">{{
                      "ROLE_MANAGEMENT.VIEW_INVOICE_APPROVAL" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-view-active-repayment" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewActiveRepayment])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ViewActiveRepayment], $event)">
                    <label for="dt-meter-installation-view-active-repayment" class="permission-label">{{
                      "ROLE_MANAGEMENT.VIEW_ACTIVE_REPAYMENT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-view-completed-payment" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewCompletedPayment])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_ViewCompletedPayment], $event)">
                    <label for="dt-meter-installation-view-completed-payment" class="permission-label">{{
                      "ROLE_MANAGEMENT.VIEW_COMPLETED_PAYMENT" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- METER VALIDATION -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigMeterValidation">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.METER_VALIDATION' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Meter_Validation_View,
                                PermissionsEnum.Meter_Validation_CreateEdit,
                                PermissionsEnum.Meter_Validation_ApproveReject,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Meter_Validation_View,
                                  PermissionsEnum.Meter_Validation_CreateEdit,
                                  PermissionsEnum.Meter_Validation_ApproveReject,       
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-validation-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meter_Validation_View])"
                      (change)="onChangePermission([PermissionsEnum.Meter_Validation_View], $event)">
                    <label for="meter-validation-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-validation-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meter_Validation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Meter_Validation_CreateEdit], $event)">
                    <label for="meter-validation-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT"
                      | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-validation-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meter_Validation_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.Meter_Validation_ApproveReject], $event)">
                    <label for="meter-validation-approve-reject" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- WORK ORDERS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigWorkOrder">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.WORK_ORDERS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.SiteVerification,
                                PermissionsEnum.Maintenance,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.SiteVerification,
                                  PermissionsEnum.Maintenance,        
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="wo-site-verification" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification], $event)">
                    <label for="wo-site-verification" class="permission-label">{{ "ROLE_MANAGEMENT.SITE_VERIFICATION" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="wo-maintenance" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Maintenance])"
                      (change)="onChangePermission([PermissionsEnum.Maintenance], $event)">
                    <label for="wo-maintenance" class="permission-label">{{ "COMMON.MAINTENANCE" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- REPORTS -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigInstallation">
                <div class="no-content-permission-header">
                  <h3 class="permission-title">{{ 'COMMON.REPORTS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Report_Misaligned,
                                PermissionsEnum.Report_DataQualityRejection,
                                PermissionsEnum.Report_Regularization
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Report_Misaligned,
                                  PermissionsEnum.Report_DataQualityRejection,
                                  PermissionsEnum.Report_Regularization       
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="report-missaligned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Report_Misaligned])"
                      (change)="onChangePermission([PermissionsEnum.Report_Misaligned], $event)">
                    <label for="report-missaligned" class="permission-label">{{ "COMMON.MISALIGNED" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="report-dq" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Report_DataQualityRejection])"
                      (change)="onChangePermission([PermissionsEnum.Report_DataQualityRejection], $event)">
                    <label for="report-dq" class="permission-label">{{ "ROLE_MANAGEMENT.DATA_QUALITY_REJECTION" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="report-regularization" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Report_Regularization])"
                      (change)="onChangePermission([PermissionsEnum.Report_Regularization], $event)">
                    <label for="report-regularization" class="permission-label">{{ "COMMON.REGULARIZATION" | translate
                      }}</label>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- METER MANAGEMENT -->
          <div [ngClass]="{ 'expanded-bg': meterManagementCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10"
                (click)="meterManagementCardExpanded = !meterManagementCardExpanded">Meter Management</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="meterManagementCardExpanded = true"
                  *ngIf="!meterManagementCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="meterManagementCardExpanded = false"
                  *ngIf="meterManagementCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="meterManagementCardExpanded" class="permission-container gap-3 scrollable-information"
              @slideToggle>
              <!-- CUSTOMER METER STOCK INVENTORY -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigMeterCustomers">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_METER_STOCK_INVENTORY' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.CustomerMeterStockInventory_View,
                                  PermissionsEnum.CustomerMeterStockInventory_Create,
                                  PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.CustomerMeterStockInventory_View,
                                  PermissionsEnum.CustomerMeterStockInventory_Create,
                                  PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-meter-stock-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_View])"
                      (change)="onChangePermission([PermissionsEnum.CustomerMeterStockInventory_View], $event)">
                    <label for="customer-meter-stock-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-meter-stock-create" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_Create])"
                      (change)="onChangePermission([PermissionsEnum.CustomerMeterStockInventory_Create], $event)">
                    <label for="customer-meter-stock-create" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-meter-stock-view-utilization" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock])"
                      (change)="onChangePermission([PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock], $event)">
                    <label for="customer-meter-stock-view-utilization" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate
                      }}</label>
                  </div>
                </div>
              </div>

              <!-- ASSET METER INVENTORY -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigMeterAssets">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MBC_DETAILS.ASSET_METER_INVENTORY' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.AssetMeterStockInventory_View,
                                  PermissionsEnum.AssetMeterStockInventory_Create,
                                  PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AssetMeterStockInventory_View,
                                  PermissionsEnum.AssetMeterStockInventory_Create,
                                  PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="asset-meter-stock-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_View])"
                      (change)="onChangePermission([PermissionsEnum.AssetMeterStockInventory_View], $event)">
                    <label for="asset-meter-stock-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-meter-stock-create" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_Create])"
                      (change)="onChangePermission([PermissionsEnum.AssetMeterStockInventory_Create], $event)">
                    <label for="asset-meter-stock-create" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-meter-stock-view-utilization" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock])"
                      (change)="onChangePermission([PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock], $event)">
                    <label for="asset-meter-stock-view-utilization" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate
                      }}</label>
                  </div>
                </div>
              </div>

              <!-- CT/VT STOCK INVENTORY -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigMeterCtvt">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MBC_DETAILS.CTVT_STOCK_INVENTORY' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.CtvtMeterStockInventory_View,
                                  PermissionsEnum.CtvtMeterStockInventory_Create,
                                  PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.CtvtMeterStockInventory_View,
                                  PermissionsEnum.CtvtMeterStockInventory_Create,
                                  PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ctvt-meter-stock-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_View])"
                      (change)="onChangePermission([PermissionsEnum.CtvtMeterStockInventory_View], $event)">
                    <label for="ctvt-meter-stock-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ctvt-meter-stock-create" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_Create])"
                      (change)="onChangePermission([PermissionsEnum.CtvtMeterStockInventory_Create], $event)">
                    <label for="ctvt-meter-stock-create" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ctvt-meter-stock-view-utilization" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock])"
                      (change)="onChangePermission([PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock], $event)">
                    <label for="ctvt-meter-stock-view-utilization" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate
                      }}</label>
                  </div>
                </div>
              </div>

              <!-- CUSTOMER DECOMISSIONED METER STOCK -->
              <div class="sub-group-container" *ngIf="permissionsService.hasAnyMeterManagement">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_DECOMMISSIONED_METER_STOCK' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.CustomerDecommissionedMeterStock_View,
                                  PermissionsEnum.CustomerDecommissionedMeterStock_Approve,
                                  PermissionsEnum.CustomerDecommissionedMeterStock_Edit
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.CustomerDecommissionedMeterStock_View,
                                  PermissionsEnum.CustomerDecommissionedMeterStock_Approve,
                                  PermissionsEnum.CustomerDecommissionedMeterStock_Edit
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="decomissined-meter-stock-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_View])"
                      (change)="onChangePermission([PermissionsEnum.CustomerDecommissionedMeterStock_View], $event)">
                    <label for="decomissined-meter-stock-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="decomissined-meter-stock-approve" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_Approve])"
                      (change)="onChangePermission([PermissionsEnum.CustomerDecommissionedMeterStock_Approve], $event)">
                    <label for="decomissined-meter-stock-approve" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="decomissined-meter-stock-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_Edit])"
                      (change)="onChangePermission([PermissionsEnum.CustomerDecommissionedMeterStock_Edit], $event)">
                    <label for="decomissined-meter-stock-edit" class="permission-label">{{ "COMMON.EDIT" | translate
                      }}</label>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- READINGS -->
          <div [ngClass]="{ 'expanded-bg': readingsCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10" (click)="readingsCardExpanded = !readingsCardExpanded">{{
                'SIDENAV.READINGS' | translate }}</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="readingsCardExpanded = true" *ngIf="!readingsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="readingsCardExpanded = false" *ngIf="readingsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="readingsCardExpanded" class="permission-container gap-3 scrollable-information" @slideToggle>
              <!-- READINGS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.READINGS' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.Readings_View
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Readings_View        
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-usage" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Readings_View])"
                      (change)="onChangePermission([PermissionsEnum.Readings_View], $event)">
                    <label for="customer-readings-usage" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                </div>
              </div>
              <!-- CUSTOMER READINGS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.READINGS.CUSTOMER_READINGS' | translate
                    }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.CustomerReadings_Usage,
                                  PermissionsEnum.CustomerReadings_Failed,
                                  PermissionsEnum.CustomerReadings_Rejected,
                                  PermissionsEnum.CustomerReadings_Inaccessible,
                                  PermissionsEnum.CustomerReadings_Inoperable
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.CustomerReadings_Usage,
                                  PermissionsEnum.CustomerReadings_Failed,
                                  PermissionsEnum.CustomerReadings_Rejected,
                                  PermissionsEnum.CustomerReadings_Inaccessible,
                                  PermissionsEnum.CustomerReadings_Inoperable         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-usage" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerReadings_Usage])"
                      (change)="onChangePermission([PermissionsEnum.CustomerReadings_Usage], $event)">
                    <label for="customer-readings-usage" class="permission-label">{{ "READING.READING_STATUS.USAGE" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-failed" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerReadings_Failed])"
                      (change)="onChangePermission([PermissionsEnum.CustomerReadings_Failed], $event)">
                    <label for="customer-readings-failed" class="permission-label">{{ "READING.READING_STATUS.FAILED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-rejected" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerReadings_Rejected])"
                      (change)="onChangePermission([PermissionsEnum.CustomerReadings_Rejected], $event)">
                    <label for="customer-readings-rejected" class="permission-label">{{
                      "READING.READING_STATUS.REJECTED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-inaccesible" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerReadings_Inaccessible])"
                      (change)="onChangePermission([PermissionsEnum.CustomerReadings_Inaccessible], $event)">
                    <label for="customer-readings-inaccesible" class="permission-label">{{
                      "READING.READING_STATUS.INACCESSIBLE" | translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-readings-inoperable" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.CustomerReadings_Inoperable])"
                      (change)="onChangePermission([PermissionsEnum.CustomerReadings_Inoperable], $event)">
                    <label for="customer-readings-inoperable" class="permission-label">{{
                      "READING.READING_STATUS.INOPERABLE" | translate }}</label>
                  </div>
                </div>
              </div>


              <!-- ASSET READINGS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.READINGS.ASSET_READINGS' | translate }}
                  </h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.AssetReadings_Usage,
                                  PermissionsEnum.AssetReadings_Failed,
                                  PermissionsEnum.AssetReadings_Rejected,
                                  PermissionsEnum.AssetReadings_Inaccessible,
                                  PermissionsEnum.AssetReadings_Inoperable
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AssetReadings_Usage,
                                  PermissionsEnum.AssetReadings_Failed,
                                  PermissionsEnum.AssetReadings_Rejected,
                                  PermissionsEnum.AssetReadings_Inaccessible,
                                  PermissionsEnum.AssetReadings_Inoperable         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="asset-readings-usage" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetReadings_Usage])"
                      (change)="onChangePermission([PermissionsEnum.AssetReadings_Usage], $event)">
                    <label for="asset-readings-usage" class="permission-label">{{ "READING.READING_STATUS.USAGE" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-readings-failed" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetReadings_Failed])"
                      (change)="onChangePermission([PermissionsEnum.AssetReadings_Failed], $event)">
                    <label for="asset-readings-failed" class="permission-label">{{ "READING.READING_STATUS.FAILED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-readings-rejected" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetReadings_Rejected])"
                      (change)="onChangePermission([PermissionsEnum.AssetReadings_Rejected], $event)">
                    <label for="asset-readings-rejected" class="permission-label">{{ "READING.READING_STATUS.REJECTED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-readings-inaccesible" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetReadings_Inaccessible])"
                      (change)="onChangePermission([PermissionsEnum.AssetReadings_Inaccessible], $event)">
                    <label for="asset-readings-inaccesible" class="permission-label">{{
                      "READING.READING_STATUS.INACCESSIBLE" | translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="asset-readings-inoperable" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetReadings_Inoperable])"
                      (change)="onChangePermission([PermissionsEnum.AssetReadings_Inoperable], $event)">
                    <label for="asset-readings-inoperable" class="permission-label">{{
                      "READING.READING_STATUS.INOPERABLE" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- ASSIGNED READINGS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.READINGS.ASSIGNED_READINGS' | translate
                    }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.AssignedReadings_Usage,
                                  PermissionsEnum.AssignedReadings_Failed,
                                  PermissionsEnum.AssignedReadings_Rejected,
                                  PermissionsEnum.AssignedReadings_Inaccessible,
                                  PermissionsEnum.AssignedReadings_Inoperable
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AssignedReadings_Usage,
                                  PermissionsEnum.AssignedReadings_Failed,
                                  PermissionsEnum.AssignedReadings_Rejected,
                                  PermissionsEnum.AssignedReadings_Inaccessible,
                                  PermissionsEnum.AssignedReadings_Inoperable         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="assigned-readings-usage" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssignedReadings_Usage])"
                      (change)="onChangePermission([PermissionsEnum.AssignedReadings_Usage], $event)">
                    <label for="assigned-readings-usage" class="permission-label">{{ "READING.READING_STATUS.USAGE" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="assigned-readings-failed" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssignedReadings_Failed])"
                      (change)="onChangePermission([PermissionsEnum.AssignedReadings_Failed], $event)">
                    <label for="assigned-readings-failed" class="permission-label">{{ "READING.READING_STATUS.FAILED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="assigned-readings-rejected" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssignedReadings_Rejected])"
                      (change)="onChangePermission([PermissionsEnum.AssignedReadings_Rejected], $event)">
                    <label for="assigned-readings-rejected" class="permission-label">{{
                      "READING.READING_STATUS.REJECTED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="assigned-readings-inaccesible" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssignedReadings_Inaccessible])"
                      (change)="onChangePermission([PermissionsEnum.AssignedReadings_Inaccessible], $event)">
                    <label for="assigned-readings-inaccesible" class="permission-label">{{
                      "READING.READING_STATUS.INACCESSIBLE" | translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="assigned-readings-inoperable" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssignedReadings_Inoperable])"
                      (change)="onChangePermission([PermissionsEnum.AssignedReadings_Inoperable], $event)">
                    <label for="assigned-readings-inoperable" class="permission-label">{{
                      "READING.READING_STATUS.INOPERABLE" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- READING SCHEDULE -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'MAIN_SIDEBAR.DETAILS_SIDEBAR.READINGS.READING_SCHEDULE' | translate
                    }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                  PermissionsEnum.ReadingsSchedule_Usage,
                                  PermissionsEnum.ReadingsSchedule_Failed,
                                  PermissionsEnum.ReadingsSchedule_Rejected,
                                  PermissionsEnum.ReadingsSchedule_Inaccessible,
                                  PermissionsEnum.ReadingsSchedule_Inoperable
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.ReadingsSchedule_Usage,
                                  PermissionsEnum.ReadingsSchedule_Failed,
                                  PermissionsEnum.ReadingsSchedule_Rejected,
                                  PermissionsEnum.ReadingsSchedule_Inaccessible,
                                  PermissionsEnum.ReadingsSchedule_Inoperable         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="reading-schedule-usage" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ReadingsSchedule_Usage])"
                      (change)="onChangePermission([PermissionsEnum.ReadingsSchedule_Usage], $event)">
                    <label for="reading-schedule-usage" class="permission-label">{{ "READING.READING_STATUS.USAGE" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="reading-schedule-failed" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ReadingsSchedule_Failed])"
                      (change)="onChangePermission([PermissionsEnum.ReadingsSchedule_Failed], $event)">
                    <label for="reading-schedule-failed" class="permission-label">{{ "READING.READING_STATUS.FAILED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="reading-schedule-rejected" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ReadingsSchedule_Rejected])"
                      (change)="onChangePermission([PermissionsEnum.ReadingsSchedule_Rejected], $event)">
                    <label for="reading-schedule-rejected" class="permission-label">{{ "READING.READING_STATUS.REJECTED"
                      | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="reading-schedule-inaccesible" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ReadingsSchedule_Inaccessible])"
                      (change)="onChangePermission([PermissionsEnum.ReadingsSchedule_Inaccessible], $event)">
                    <label for="reading-schedule-inaccesible" class="permission-label">{{
                      "READING.READING_STATUS.INACCESSIBLE" | translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="reading-schedule-inoperable" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.ReadingsSchedule_Inoperable])"
                      (change)="onChangePermission([PermissionsEnum.ReadingsSchedule_Inoperable], $event)">
                    <label for="reading-schedule-inoperable" class="permission-label">{{
                      "READING.READING_STATUS.INOPERABLE" | translate }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- CRUD -->
          <div [ngClass]="{ 'expanded-bg': crudCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10" (click)="crudCardExpanded = !crudCardExpanded">
                {{'ROLE_MANAGEMENT.CRUD' | translate }}</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="crudCardExpanded = true" *ngIf="!crudCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="crudCardExpanded = false" *ngIf="crudCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="crudCardExpanded" class="permission-container gap-3 scrollable-information" @slideToggle>
              <!-- AREAS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.UT.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Area_View,
                                PermissionsEnum.Area_CreateEdit,
                                PermissionsEnum.Area_Delete
                              ])" (change)="
                              onChangePermission([
                                PermissionsEnum.Area_View,
                                PermissionsEnum.Area_CreateEdit,
                                PermissionsEnum.Area_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="area-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Area_View])"
                      (change)="onChangePermission([PermissionsEnum.Area_View], $event)">
                    <label for="area-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="area-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Area_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Area_CreateEdit], $event)">
                    <label for="area-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="area-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Area_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Area_Delete], $event)">
                    <label for="area-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- REGIONS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.BU.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Region_View,
                                PermissionsEnum.Region_CreateEdit,
                                PermissionsEnum.Region_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Region_View,
                                  PermissionsEnum.Region_CreateEdit,
                                  PermissionsEnum.Region_Delete           
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="region-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Region_View])"
                      (change)="onChangePermission([PermissionsEnum.Region_View], $event)">
                    <label for="region-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="region-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Region_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Region_CreateEdit], $event)">
                    <label for="region-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="region-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Region_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Region_Delete], $event)">
                    <label for="region-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- TARIFFS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.TARIFF.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Tariff_View,
                                PermissionsEnum.Tariff_CreateEdit,
                                PermissionsEnum.Tariff_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Tariff_View,
                                  PermissionsEnum.Tariff_CreateEdit,
                                  PermissionsEnum.Tariff_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="tariff-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Tariff_View])"
                      (change)="onChangePermission([PermissionsEnum.Tariff_View], $event)">
                    <label for="tariff-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="tariff-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Tariff_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Tariff_CreateEdit], $event)">
                    <label for="tariff-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="tariff-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Tariff_Delete])"
                      (change)="onChangePermission([PermissionsEnum.Tariff_Delete], $event)">
                    <label for="tariff-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- METER TYPES -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.MBC_DETAILS.METER_TYPE.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.MeterType_View,
                                PermissionsEnum.MeterType_CreateEdit,
                                PermissionsEnum.MeterType_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.MeterType_View,
                                  PermissionsEnum.MeterType_CreateEdit,
                                  PermissionsEnum.MeterType_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-type-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterType_View])"
                      (change)="onChangePermission([PermissionsEnum.MeterType_View], $event)">
                    <label for="meter-type-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-type-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterType_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.MeterType_CreateEdit], $event)">
                    <label for="meter-type-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-type-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterType_Delete])"
                      (change)="onChangePermission([PermissionsEnum.MeterType_Delete], $event)">
                    <label for="meter-type-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- ASSET RATINGS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.ASSET_RATING.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.AssetRating_View,
                                PermissionsEnum.AssetRating_CreateEdit,
                                PermissionsEnum.AssetRating_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AssetRating_View,
                                  PermissionsEnum.AssetRating_CreateEdit,
                                  PermissionsEnum.AssetRating_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="asset-rating-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetRating_View])"
                      (change)="onChangePermission([PermissionsEnum.AssetRating_View], $event)">
                    <label for="asset-rating-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-rating-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetRating_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.AssetRating_CreateEdit], $event)">
                    <label for="asset-rating-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-rating-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetRating_Delete])"
                      (change)="onChangePermission([PermissionsEnum.AssetRating_Delete], $event)">
                    <label for="asset-rating-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>

              </div>
              <!-- ASSET STATUS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.ASSET_STATUS.SINGLE' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.AssetStatus_View,
                                PermissionsEnum.AssetStatus_CreateEdit,
                                PermissionsEnum.AssetStatus_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AssetStatus_View,
                                  PermissionsEnum.AssetStatus_CreateEdit,
                                  PermissionsEnum.AssetStatus_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="asset-status-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetStatus_View])"
                      (change)="onChangePermission([PermissionsEnum.AssetStatus_View], $event)">
                    <label for="asset-status-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-rating-status-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetStatus_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.AssetStatus_CreateEdit], $event)">
                    <label for="asset-rating-status-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="asset-status-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AssetStatus_Delete])"
                      (change)="onChangePermission([PermissionsEnum.AssetStatus_Delete], $event)">
                    <label for="asset-status-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>

              </div>
              <!-- METER PRICE -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.METER_PRICE.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.MeterPrice_View,
                                PermissionsEnum.MeterPrice_CreateEdit,
                                PermissionsEnum.MeterPrice_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.MeterPrice_View,
                                  PermissionsEnum.MeterPrice_CreateEdit,
                                  PermissionsEnum.MeterPrice_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-price-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterPrice_View])"
                      (change)="onChangePermission([PermissionsEnum.MeterPrice_View], $event)">
                    <label for="meter-price-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-price-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterPrice_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.MeterPrice_CreateEdit], $event)">
                    <label for="meter-price-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-price-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterPrice_Delete])"
                      (change)="onChangePermission([PermissionsEnum.MeterPrice_Delete], $event)">
                    <label for="meter-price-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- DT METER TYPE -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.DT_METER_TYPE.PLURAL' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.DtMeterType_View,
                                PermissionsEnum.DtMeterType_CreateEdit,
                                PermissionsEnum.DtMeterType_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.DtMeterType_View,
                                  PermissionsEnum.DtMeterType_CreateEdit,
                                  PermissionsEnum.DtMeterType_Delete           
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-type-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterType_View])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterType_View], $event)">
                    <label for="dt-meter-type-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-type-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterType_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterType_CreateEdit], $event)">
                    <label for="dt-meter-type-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-type-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterType_Delete])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterType_Delete], $event)">
                    <label for="dt-meter-type-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- CUSTOMER ACCOUNT -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "COMMON.CUSTOMER.PLURAL" | translate }} {{ "ROLE_MANAGEMENT.CRUD" |
                    translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Customer_ViewCrud,
                                PermissionsEnum.Customer_CreateEditCrud,
                                PermissionsEnum.Customer_AssignForDecommission,
                                PermissionsEnum.Customer_CrudDownload,
                                PermissionsEnum.Customer_ServiceRequestViewCrud,
                                PermissionsEnum.Customer_NewEntryViewCrud,
                                PermissionsEnum.Customer_FailedSyncNotification,
                                PermissionsEnum.Customer_FeederBandAlignmentNotification
                              ])"
                              (change)="
                              onChangePermission([
                                  PermissionsEnum.Customer_ViewCrud,
                                  PermissionsEnum.Customer_CreateEditCrud,
                                  PermissionsEnum.Customer_AssignForDecommission,
                                  PermissionsEnum.Customer_CrudDownload,
                                  PermissionsEnum.Customer_ServiceRequestViewCrud,
                                  PermissionsEnum.Customer_NewEntryViewCrud,
                                  PermissionsEnum.Customer_FailedSyncNotification,
                                  PermissionsEnum.Customer_FeederBandAlignmentNotification
                                ],
                                $event
                              )
                          " />
                          <span class="slider round"></span>
                      </label>
                    </div>
                    <div class="permission-options">
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-view" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_ViewCrud])" 
                          (change)="onChangePermission([PermissionsEnum.Customer_ViewCrud], $event)">
                          <label for="customer-crud-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-create-edit" class="custom-checkbox"
                            [checked]="isChecked([PermissionsEnum.Customer_CreateEditCrud])" 
                          (change)="onChangePermission([PermissionsEnum.Customer_CreateEditCrud], $event)">
                          <label for="customer-crud-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-assign-decomissioning" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_AssignForDecommission])" 
                          (change)="onChangePermission([PermissionsEnum.Customer_AssignForDecommission], $event)">
                          <label for="customer-crud-assign-decomissioning" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN_FOR_DECOMMISIONING" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-download" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_CrudDownload])"
                          (change)="onChangePermission([PermissionsEnum.Customer_CrudDownload], $event)">
                          <label for="customer-crud-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                      </div>
                    </div>
                    <div class="permission-options">
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-service-request" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_ServiceRequestViewCrud])"
                          (change)="onChangePermission([PermissionsEnum.Customer_ServiceRequestViewCrud], $event)">
                          <label for="customer-crud-service-request" class="permission-label">{{ "ROLE_MANAGEMENT.SERVICE_REQUEST" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-new-entry" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_NewEntryViewCrud])"
                          (change)="onChangePermission([PermissionsEnum.Customer_NewEntryViewCrud], $event)">
                          <label for="customer-crud-new-entry" class="permission-label">{{ "ROLE_MANAGEMENT.NEW_ENTRY" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-failed-sync-notification" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_FailedSyncNotification])"
                          (change)="onChangePermission([PermissionsEnum.Customer_FailedSyncNotification], $event)">
                          <label for="customer-crud-failed-sync-notification" class="permission-label">{{ "ROLE_MANAGEMENT.FAILED_SYNC_NOTIFICATION" | translate }}</label>
                      </div>
                      <div class="permission-item">
                          <input type="checkbox" id="customer-crud-feeder-band-alignment-notification" class="custom-checkbox"
                          [checked]="isChecked([PermissionsEnum.Customer_FeederBandAlignmentNotification])"
                          (change)="onChangePermission([PermissionsEnum.Customer_FeederBandAlignmentNotification], $event)">
                          <label for="customer-crud-feeder-band-alignment-notification" class="permission-label">{{ "ROLE_MANAGEMENT.FEEDER_BAND_ALIGNMENT_NOTIFICATION" | translate }}</label>
                      </div>
                    </div>
                  </div>
              <!-- BILLING ACCOUNTS -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "COMMON.BILLING_ACCOUNTS.PLURAL" | translate }} </h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.BillingAccounts_View,
                                PermissionsEnum.BillingAccounts_CreateEdit,
                                PermissionsEnum.BillingAccounts_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.BillingAccounts_View,
                                  PermissionsEnum.BillingAccounts_CreateEdit,
                                  PermissionsEnum.BillingAccounts_Delete         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="billing-accounts-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.BillingAccounts_View])"
                      (change)="onChangePermission([PermissionsEnum.BillingAccounts_View], $event)">
                    <label for="billing-accounts-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="billing-accounts-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.BillingAccounts_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.BillingAccounts_CreateEdit], $event)">
                    <label for="billing-accounts-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT"
                      | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="billing-accounts-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.BillingAccounts_Delete])"
                      (change)="onChangePermission([PermissionsEnum.BillingAccounts_Delete], $event)">
                    <label for="billing-accounts-delete" class="permission-label">{{ "COMMON.DELETE" | translate
                      }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- SETTINGS -->
          <div [ngClass]="{ 'expanded-bg': settingsCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10" (click)="settingsCardExpanded = !settingsCardExpanded">
                Settings</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="settingsCardExpanded = true" *ngIf="!settingsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="settingsCardExpanded = false" *ngIf="settingsCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="settingsCardExpanded" class="permission-container gap-3 scrollable-information" @slideToggle>
              <!-- USER MANAGEMENT -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.USER_MANAGEMENT' | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.UserManagement_View,
                                PermissionsEnum.UserManagement_CreateEdit,
                                PermissionsEnum.UserManagement_Delete,
                                PermissionsEnum.UserManagement_BulkAssign,
                                PermissionsEnum.Organization_Create
                              ])" (change)="
                              onChangePermission([
                                PermissionsEnum.UserManagement_View,
                                PermissionsEnum.UserManagement_CreateEdit,
                                PermissionsEnum.UserManagement_Delete,
                                PermissionsEnum.UserManagement_BulkAssign,
                                PermissionsEnum.Organization_Create             
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="um-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.UserManagement_View])"
                      (change)="onChangePermission([PermissionsEnum.UserManagement_View], $event)">
                    <label for="um-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="um-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.UserManagement_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.UserManagement_CreateEdit], $event)">
                    <label for="um-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="um-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.UserManagement_Delete])"
                      (change)="onChangePermission([PermissionsEnum.UserManagement_Delete], $event)">
                    <label for="um-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="um-bulk-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.UserManagement_BulkAssign])"
                      (change)="onChangePermission([PermissionsEnum.UserManagement_BulkAssign], $event)">
                    <label for="um-bulk-assign" class="permission-label">{{ "ROLE_MANAGEMENT.BULK_ASSIGN" | translate
                      }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="um-create-org" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Organization_Create])"
                      (change)="onChangePermission([PermissionsEnum.Organization_Create], $event)">
                    <label for="um-create-org" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_ORGANIZATION" |
                      translate }}</label>
                  </div>
                </div>
              </div>
              <!-- ROLE MANAGEMENT -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'ROLE_MANAGEMENT.TITLE' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.RoleManagement_View,
                                PermissionsEnum.RoleManagement_CreateEdit,
                                PermissionsEnum.RoleManagement_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.RoleManagement_View,
                                  PermissionsEnum.RoleManagement_CreateEdit,
                                  PermissionsEnum.RoleManagement_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="rm-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.RoleManagement_View])"
                      (change)="onChangePermission([PermissionsEnum.RoleManagement_View], $event)">
                    <label for="rm-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rm-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.RoleManagement_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.RoleManagement_CreateEdit], $event)">
                    <label for="rm-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rm-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.RoleManagement_Delete])"
                      (change)="onChangePermission([PermissionsEnum.RoleManagement_Delete], $event)">
                    <label for="rm-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- Network Structure -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.NETWORK_STRUCTURE' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.NetworkStructure_View,
                                PermissionsEnum.NetworkStructure_CreateEdit,
                                PermissionsEnum.NetworkStructure_Assign,
                                PermissionsEnum.NetworkStructure_ApproveReject,
                                PermissionsEnum.NetworkStructure_Review,
                                PermissionsEnum.NetworkStructure_AuditReview,
                                PermissionsEnum.NetworkStructure_GisReview,
                                PermissionsEnum.NetworkStructure_RecallValidated,
                                PermissionsEnum.NetworkStructure_RecallAssigned,
                                PermissionsEnum.NetworkStructure_Download,
                                PermissionsEnum.NetworkStructure_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.NetworkStructure_View,
                                  PermissionsEnum.NetworkStructure_CreateEdit,
                                  PermissionsEnum.NetworkStructure_Assign,
                                  PermissionsEnum.NetworkStructure_ApproveReject,
                                  PermissionsEnum.NetworkStructure_Review,
                                  PermissionsEnum.NetworkStructure_AuditReview,
                                  PermissionsEnum.NetworkStructure_GisReview,
                                  PermissionsEnum.NetworkStructure_RecallValidated,
                                  PermissionsEnum.NetworkStructure_RecallAssigned,
                                  PermissionsEnum.NetworkStructure_Download,
                                  PermissionsEnum.NetworkStructure_Delete
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ns-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_View])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_View], $event)">
                    <label for="ns-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_CreateEdit], $event)">
                    <label for="ns-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_Delete])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_Delete], $event)">
                    <label for="ns-delete" class="permission-label">{{ "ROLE_MANAGEMENT.DELETE" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_ApproveReject], $event)">
                    <label for="ns-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ns-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_Review])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_Review], $event)">
                    <label for="ns-review" class="permission-label">{{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_AuditReview], $event)">
                    <label for="ns-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-gis-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_GisReview])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_GisReview], $event)">
                    <label for="ns-gis-review" class="permission-label">{{ "ROLE_MANAGEMENT.GIS_REVIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_RecallValidated], $event)">
                    <label for="ns-recall-validated" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_VALIDATED" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-recall-assigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_RecallAssigned], $event)">
                    <label for="ns-recall-assigned" class="permission-label">{{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" |
                      translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ns-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_Download])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_Download], $event)">
                    <label for="ns-download" class="permission-label">{{ "ROLE_MANAGEMENT.DOWNLOAD" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ns-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkStructure_Assign])"
                      (change)="onChangePermission([PermissionsEnum.NetworkStructure_Assign], $event)">
                    <label for="ns-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- Schematic Diagram -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'UTILITY_MANAGEMENT.SCHEMATIC_DIAGRAM' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.SchematicDiagram_View,
                                PermissionsEnum.SchematicDiagram_CreateEdit
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.SchematicDiagram_View,
                                  PermissionsEnum.SchematicDiagram_CreateEdit
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="sd-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SchematicDiagram_View])"
                      (change)="onChangePermission([PermissionsEnum.SchematicDiagram_View], $event)">
                    <label for="sd-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="sd-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SchematicDiagram_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.SchematicDiagram_CreateEdit], $event)">
                    <label for="sd-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                </div>
              </div>
              <!-- Network Entity Classes -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.NETWORK_ENTITY_CLASSES' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.NetworkEntityClasses_View,
                                PermissionsEnum.NetworkEntityClasses_CreateEdit,
                                PermissionsEnum.NetworkEntityClasses_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.NetworkEntityClasses_View,
                                  PermissionsEnum.NetworkEntityClasses_CreateEdit,
                                  PermissionsEnum.NetworkEntityClasses_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="nec-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_View])"
                      (change)="onChangePermission([PermissionsEnum.NetworkEntityClasses_View], $event)">
                    <label for="nec-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="nec-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.NetworkEntityClasses_CreateEdit], $event)">
                    <label for="nec-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="nec-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_Delete])"
                      (change)="onChangePermission([PermissionsEnum.NetworkEntityClasses_Delete], $event)">
                    <label for="nec-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- DATA MODEL CUSTOMIZATION -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'DATA_MODEL_CUSTOMIZATION.TITLE' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.DataModelCustomization_View,
                                PermissionsEnum.DataModelCustomization_CreateEdit,
                                PermissionsEnum.DataModelCustomization_Delete
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.DataModelCustomization_View,
                                  PermissionsEnum.DataModelCustomization_CreateEdit,
                                  PermissionsEnum.DataModelCustomization_Delete            
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dmc-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DataModelCustomization_View])"
                      (change)="onChangePermission([PermissionsEnum.DataModelCustomization_View], $event)">
                    <label for="dmc-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dmc-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DataModelCustomization_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.DataModelCustomization_CreateEdit], $event)">
                    <label for="dmc-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dmc-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DataModelCustomization_Delete])"
                      (change)="onChangePermission([PermissionsEnum.DataModelCustomization_Delete], $event)">
                    <label for="dmc-delete" class="permission-label">{{ "COMMON.DELETE" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- PAYMENT HISTORY -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.PAYMENT_HISTORY' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.PaymentHistory_View,
                                PermissionsEnum.PaymentHistory_Download
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.PaymentHistory_View,
                                  PermissionsEnum.PaymentHistory_Download
                              ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="payment-history-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.PaymentHistory_View])"
                      (change)="onChangePermission([PermissionsEnum.PaymentHistory_View], $event)">
                    <label for="payment-history-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="payment-history-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.PaymentHistory_Download])"
                      (change)="onChangePermission([PermissionsEnum.PaymentHistory_Download], $event)">
                    <label for="payment-history-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- Settlement -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'SIDENAV.SETTLEMENTS' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Settlement_View,
                                PermissionsEnum.Settlement_Download
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Settlement_View,
                                  PermissionsEnum.Settlement_Download
                              ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="settlement-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Settlement_View])"
                      (change)="onChangePermission([PermissionsEnum.Settlement_View], $event)">
                    <label for="settlement-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="settlement-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Settlement_Download])"
                      (change)="onChangePermission([PermissionsEnum.Settlement_Download], $event)">
                    <label for="settlement-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- AUDIT LOG -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'COMMON.AUDIT_LOG' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.AuditLog_View,
                                PermissionsEnum.AuditLog_Download
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AuditLog_View,
                                  PermissionsEnum.AuditLog_Download           
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="audit-log-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AuditLog_View])"
                      (change)="onChangePermission([PermissionsEnum.AuditLog_View], $event)">
                    <label for="audit-log-view" class="permission-label">{{ "AUDIT_TRAIL.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="audit-log-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AuditLog_Download])"
                      (change)="onChangePermission([PermissionsEnum.AuditLog_Download], $event)">
                    <label for="audit-log-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate }}</label>
                  </div>
                </div>
              </div>
              <!-- AUDIT TRAIL -->
              <div class="sub-group-container">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'AUDIT_TRAIL.NAME' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.AuditTrail_View,
                                PermissionsEnum.AuditTrail_Download
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.AuditTrail_View,
                                  PermissionsEnum.AuditTrail_Download           
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="audit-trail-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AuditTrail_View])"
                      (change)="onChangePermission([PermissionsEnum.AuditTrail_View], $event)">
                    <label for="audit-trail-view" class="permission-label">{{ "AUDIT_TRAIL.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="audit-trail-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AuditTrail_Download])"
                      (change)="onChangePermission([PermissionsEnum.AuditTrail_Download], $event)">
                    <label for="audit-trail-download" class="permission-label">{{ "AUDIT_TRAIL.DOWNLOAD" | translate
                      }}</label>
                  </div>
                </div>
              </div>
              <!-- AI CHAT -->
              <div class="sub-group-container" *ngIf="permissionsService.hasDashboardConfigAiWidget">
                <div class="permission-header">
                  <h3 class="permission-title">{{ 'CHAT_AI.TITLE' | translate}}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([PermissionsEnum.AiChat_Use])"
                      (change)="onChangePermission([PermissionsEnum.AiChat_Use], $event)" />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ai-chat-use" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.AiChat_Use])"
                      (change)="onChangePermission([PermissionsEnum.AiChat_Use], $event)">
                    <label for="ai-chat-use" class="permission-label">{{ "CHAT_AI.USE" | translate }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- MOBILE PERMISSIONS -->
        <div *ngIf="currentRole.systemComponent == 1"
          [ngClass]="{ 'disable-div': !permissionsService.isRoleManagementCreateEditAllowed }">
          <!-- MOBILE ASSETS -->
          <div [ngClass]="{ 'expanded-bg': assetsMobileCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10"
                (click)="assetsMobileCardExpanded = !assetsMobileCardExpanded">Assets</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="assetsMobileCardExpanded = true"
                  *ngIf="!assetsMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="assetsMobileCardExpanded = false"
                  *ngIf="assetsMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="assetsMobileCardExpanded" class="permission-container gap-3 scrollable-information"
              @slideToggle>
              <!-- CUSTOMERS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigBuildings && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "COMMON.CUSTOMER.PLURAL" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Customer_View,
                                PermissionsEnum.Customer_CreateEdit,
                                PermissionsEnum.Customer_Retag,
                                PermissionsEnum.Customer_Sweep,
                                PermissionsEnum.Customer_Regularization
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Customer_View,
                                  PermissionsEnum.Customer_CreateEdit,
                                  PermissionsEnum.Customer_Retag,
                                  PermissionsEnum.Customer_Sweep,
                                  PermissionsEnum.Customer_Regularization          
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_View])"
                      (change)="onChangePermission([PermissionsEnum.Customer_View], $event)">
                    <label for="customer-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Customer_CreateEdit], $event)">
                    <label for="customer-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Customer_Retag], $event)">
                    <label for="customer-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-regularization" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_Regularization])"
                      (change)="onChangePermission([PermissionsEnum.Customer_Regularization], $event)">
                    <label for="customer-mobile-regularization" class="permission-label">{{ "COMMON.REGULARIZATION" |
                      translate }}</label>
                  </div>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-sweep" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_Sweep])"
                      (change)="onChangePermission([PermissionsEnum.Customer_Sweep], $event)">
                    <label for="customer-mobile-sweep" class="permission-label">{{ "COMMON.SWEEP" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="customer-mobile-global-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Customer_GlobalView])"
                      (change)="onChangePermission([PermissionsEnum.Customer_GlobalView], $event)">
                    <label for="customer-mobile-global-view" class="permission-label">{{ "COMMON.GLOBAL_VIEW" |
                      translate }}</label>
                  </div>
                </div>
              </div>

              <!-- DISTRIBUTION SUBSTATIONS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigDTS && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "DASHBOARD.ASSET_BREAKDOWN.DISTRIBUTION_SUBSTATIONS" | translate }}
                  </h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Transformers_View,
                                PermissionsEnum.Transformers_CreateEdit,
                                PermissionsEnum.Transformers_Retag
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Transformers_View,
                                  PermissionsEnum.Transformers_CreateEdit,
                                  PermissionsEnum.Transformers_Retag         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="ts-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_View])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_View], $event)">
                    <label for="ts-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ts-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_CreateEdit], $event)">
                    <label for="ts-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="ts-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Transformers_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Transformers_Retag], $event)">
                    <label for="ts-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- RMUs -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigRmus && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "RMU.PLURAL" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Rmus_View,
                                PermissionsEnum.Rmus_CreateEdit,
                                PermissionsEnum.Rmus_Retag
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Rmus_View,
                                  PermissionsEnum.Rmus_CreateEdit,
                                  PermissionsEnum.Rmus_Retag
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_View])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_View], $event)">
                    <label for="rmu-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_CreateEdit], $event)">
                    <label for="rmu-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="rmu-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Rmus_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Rmus_Retag], $event)">
                    <label for="rmu-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- LV POLES -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigPoles && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.LV_POLES" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Pole_View,
                                PermissionsEnum.Pole_CreateEdit,
                                PermissionsEnum.Pole_Retag,
                                PermissionsEnum.Pole_Sweep
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Pole_View,
                                  PermissionsEnum.Pole_CreateEdit,
                                  PermissionsEnum.Pole_Retag,
                                  PermissionsEnum.Pole_Sweep         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="pole-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_View])"
                      (change)="onChangePermission([PermissionsEnum.Pole_View], $event)">
                    <label for="pole-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Pole_CreateEdit], $event)">
                    <label for="pole-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Retag], $event)">
                    <label for="pole-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="pole-mobile-sweep" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Pole_Sweep])"
                      (change)="onChangePermission([PermissionsEnum.Pole_Sweep], $event)">
                    <label for="pole-mobile-sweep" class="permission-label">{{ "COMMON.SWEEP" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- MV POLES -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigPoles && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.MV_POLES" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.MVPole_View,
                                PermissionsEnum.MVPole_CreateEdit,
                                PermissionsEnum.MVPole_Delete,
                                PermissionsEnum.MVPole_Assign,
                                PermissionsEnum.MVPole_ApproveReject,
                                PermissionsEnum.MVPole_AuditReview,
                                PermissionsEnum.MVPole_RecallAssigned,
                                PermissionsEnum.MVPole_Retag,
                                PermissionsEnum.MVPole_RecallValidated,
                                PermissionsEnum.MVPole_Download
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.MVPole_View,
                                  PermissionsEnum.MVPole_CreateEdit,
                                  PermissionsEnum.MVPole_Delete,
                                  PermissionsEnum.MVPole_Assign,
                                  PermissionsEnum.MVPole_ApproveReject,
                                  PermissionsEnum.MVPole_AuditReview,
                                  PermissionsEnum.MVPole_RecallAssigned,
                                  PermissionsEnum.MVPole_Retag,
                                  PermissionsEnum.MVPole_RecallValidated,
                                  PermissionsEnum.MVPole_Download         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_View])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_View], $event)">
                    <label for="mv-pole-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_CreateEdit], $event)">
                    <label for="mv-pole-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-delete" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Delete])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Delete], $event)">
                    <label for="mv-pole-mobile-delete" class="permission-label">{{ "COMMON.DELETE" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-assign" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Assign])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Assign], $event)">
                    <label for="mv-pole-mobile-assign" class="permission-label">{{ "ROLE_MANAGEMENT.ASSIGN" | translate
                      }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_ApproveReject], $event)">
                    <label for="mv-pole-mobile-approve-reject" class="permission-label">{{
                      "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-audit-review" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_AuditReview])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_AuditReview], $event)">
                    <label for="mv-pole-mobile-audit-review" class="permission-label">{{ "ROLE_MANAGEMENT.AUDIT_REVIEW"
                      | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-recall-asigned" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_RecallAssigned])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_RecallAssigned], $event)">
                    <label for="mv-pole-mobile-recall-asigned" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Retag])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Retag], $event)">
                    <label for="mv-pole-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                </div>

                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-recall-validated" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_RecallValidated])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_RecallValidated], $event)">
                    <label for="mv-pole-mobile-recall-validated" class="permission-label">{{
                      "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="mv-pole-mobile-download" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MVPole_Download])"
                      (change)="onChangePermission([PermissionsEnum.MVPole_Download], $event)">
                    <label for="mv-pole-mobile-download" class="permission-label">{{ "COMMON.DOWNLOAD" | translate
                      }}</label>
                  </div>
                </div>
              </div>

              <!-- BUILDINGS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigPoles && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "COMMON.BUILDING.PLURAL" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Building_View,
                                PermissionsEnum.Building_CreateEdit,
                                PermissionsEnum.Building_Retag,
                                PermissionsEnum.Building_Sweep
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Building_View,
                                  PermissionsEnum.Building_CreateEdit,
                                  PermissionsEnum.Building_Retag,
                                  PermissionsEnum.Building_Sweep        
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="building-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_View])"
                      (change)="onChangePermission([PermissionsEnum.Building_View], $event)">
                    <label for="building-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Building_CreateEdit], $event)">
                    <label for="building-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Building_Retag], $event)">
                    <label for="building-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="building-mobile-sweep" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Building_Sweep])"
                      (change)="onChangePermission([PermissionsEnum.Building_Sweep], $event)">
                    <label for="building-mobile-sweep" class="permission-label">{{ "COMMON.SWEEP" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- METERS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigMeters && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "METERS.PLURAL" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Meters_View,
                                PermissionsEnum.Meters_CreateEdit,
                                PermissionsEnum.Meters_Retag
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Meters_View,
                                  PermissionsEnum.Meters_CreateEdit,
                                  PermissionsEnum.Meters_Retag      
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_View])"
                      (change)="onChangePermission([PermissionsEnum.Meters_View], $event)">
                    <label for="meter-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Meters_CreateEdit], $event)">
                    <label for="meter-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-mobile-retag" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meters_Retag])"
                      (change)="onChangePermission([PermissionsEnum.Meters_Retag], $event)">
                    <label for="meter-mobile-retag" class="permission-label">{{ "COMMON.RETAG" | translate }}</label>
                  </div>
                </div>
              </div>

            </div>


          </div>
          <!-- MOBILE OPERATIONS -->
          <div [ngClass]="{ 'expanded-bg': operationsMobileCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10"
                (click)="operationsMobileCardExpanded = !operationsMobileCardExpanded">Operations</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="operationsMobileCardExpanded = true"
                  *ngIf="!operationsMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="operationsMobileCardExpanded = false"
                  *ngIf="operationsMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="operationsMobileCardExpanded" class="permission-container gap-3 scrollable-information"
              @slideToggle>
              <!-- SURVEYS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigSurvey && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Survey_View,
                                PermissionsEnum.Survey_CreateEdit,
                                PermissionsEnum.Survey_Create_New,
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Survey_View,
                                  PermissionsEnum.Survey_CreateEdit,
                                  PermissionsEnum.Survey_Create_New,         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="survey-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_View])"
                      (change)="onChangePermission([PermissionsEnum.Survey_View], $event)">
                    <label for="survey-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Survey_CreateEdit], $event)">
                    <label for="survey-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="survey-mobile-create-new" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Survey_Create_New])"
                      (change)="onChangePermission([PermissionsEnum.Survey_Create_New], $event)">
                    <label for="survey-mobile-create-new" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_NEW" |
                      translate }}</label>
                  </div>
                </div>
              </div>

              <!-- CUSTOMER INSTALLATION -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigInstallation && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "ROLE_MANAGEMENT.CUSTOMER_INSTALLATION" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Installation_View,
                                PermissionsEnum.Installation_CreateEdit
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Installation_View,
                                  PermissionsEnum.Installation_CreateEdit
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="installation-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_View])"
                      (change)="onChangePermission([PermissionsEnum.Installation_View], $event)">
                    <label for="installation-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="installation-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Installation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Installation_CreateEdit], $event)">
                    <label for="installation-mobile-create-edit" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- DT METER INSTALLATION (Mobile) -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigDtMeterInstallation && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "ROLE_MANAGEMENT.DT_METER_INSTALLATION" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.DtMeterInstallation_View,
                                PermissionsEnum.DtMeterInstallation_CreateEdit,
                                PermissionsEnum.DtMeterInstallation_CreateNew
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.DtMeterInstallation_View,
                                  PermissionsEnum.DtMeterInstallation_CreateEdit,
                                  PermissionsEnum.DtMeterInstallation_CreateNew
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_View])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_View], $event)">
                    <label for="dt-meter-installation-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_CreateEdit], $event)">
                    <label for="dt-meter-installation-mobile-create-edit" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="dt-meter-installation-mobile-create-new" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateNew])"
                      (change)="onChangePermission([PermissionsEnum.DtMeterInstallation_CreateNew], $event)">
                    <label for="dt-meter-installation-mobile-create-new" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_NEW" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- METER VALIDATION -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigSurvey && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "SIDENAV.METER_VALIDATION" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.Meter_Validation_View,
                                PermissionsEnum.Meter_Validation_CreateEdit
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.Meter_Validation_View,
                                  PermissionsEnum.Meter_Validation_CreateEdit         
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-validation-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meter_Validation_View])"
                      (change)="onChangePermission([PermissionsEnum.Meter_Validation_View], $event)">
                    <label for="meter-validation-mobile-view" class="permission-label">{{ "ROLE_MANAGEMENT.VIEW" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="meter-validation-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Meter_Validation_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.Meter_Validation_CreateEdit], $event)">
                    <label for="meter-validation-mobile-create-edit" class="permission-label">{{
                      "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- WORK ORDERS -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigWorkOrder && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "ROLE_MANAGEMENT.WORK_ORDER" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                            isChecked([
                              PermissionsEnum.Maintenance,
                              PermissionsEnum.Disconnection,
                              PermissionsEnum.Outages
                            ])" (change)="
                            onChangePermission([
                                PermissionsEnum.Maintenance,
                                PermissionsEnum.Disconnection,
                                PermissionsEnum.Outages
                              ],
                              $event
                            ) " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="wo-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Maintenance])"
                      (change)="onChangePermission([PermissionsEnum.Maintenance], $event)">
                    <label for="wo-mobile-create-edit" class="permission-label">{{ "COMMON.MAINTENANCE" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="wo-mobile-disconnection" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Disconnection])"
                      (change)="onChangePermission([PermissionsEnum.Disconnection], $event)">
                    <label for="wo-mobile-disconnection" class="permission-label">{{ "COMMON.DISCONNECTION" | translate
                      }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="wo-mobile-outages" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.Outages])"
                      (change)="onChangePermission([PermissionsEnum.Outages], $event)">
                    <label for="wo-mobile-outages" class="permission-label">{{ "COMMON.OUTAGES" | translate }}</label>
                  </div>
                </div>
              </div>

              <!-- SITE VERIFICATION -->
              <div class="sub-group-container" *ngIf="!currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                            isChecked([
                              PermissionsEnum.SiteVerification_View,
                              PermissionsEnum.SiteVerification_CreateEdit,
                              PermissionsEnum.SiteVerification_ApproveReject
                            ])" (change)="
                            onChangePermission([
                                PermissionsEnum.SiteVerification_View,
                                PermissionsEnum.SiteVerification_CreateEdit,
                                PermissionsEnum.SiteVerification_ApproveReject
                              ],
                              $event
                            ) " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="sv-mobile-view" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_View])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_View], $event)">
                    <label for="sv-mobile-view" class="permission-label">{{ "COMMON.VIEW" | translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="sv-mobile-create-edit" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_CreateEdit])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_CreateEdit], $event)">
                    <label for="sv-mobile-create-edit" class="permission-label">{{ "ROLE_MANAGEMENT.CREATE_EDIT" |
                      translate }}</label>
                  </div>
                  <div class="permission-item">
                    <input type="checkbox" id="sv-mobile-approve-reject" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.SiteVerification_ApproveReject])"
                      (change)="onChangePermission([PermissionsEnum.SiteVerification_ApproveReject], $event)">
                    <label for="sv-mobile-approve-reject" class="permission-label">{{ "ROLE_MANAGEMENT.APPROVE_REJECT" |
                      translate }}</label>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <!-- MOBILE METER MANAGEMENT -->
          <div [ngClass]="{ 'expanded-bg': meterManagementMobileCardExpanded }"
            class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="asset-card-header row">
              <h2 class="card-title asset-card-title col-10"
                (click)="meterManagementMobileCardExpanded = !meterManagementMobileCardExpanded">{{
                'SIDENAV.METER_MANAGEMENT' | translate }}</h2>
              <div class="collapse-arrow col-2">
                <button class="action-button" (click)="meterManagementMobileCardExpanded = true"
                  *ngIf="!meterManagementMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="action-button" (click)="meterManagementMobileCardExpanded = false"
                  *ngIf="meterManagementMobileCardExpanded">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="meterManagementMobileCardExpanded" class="permission-container gap-3 scrollable-information"
              @slideToggle>
              <!-- METER READING -->
              <div class="sub-group-container"
                *ngIf="permissionsService.hasDashboardConfigReadings && !currentRole.isDisabled">
                <div class="permission-header">
                  <h3 class="permission-title">{{ "COMMON.MBC_DETAILS.METER_READINGS" | translate }}</h3>
                  <label class="switch">
                    <input type="checkbox" [checked]="
                              isChecked([
                                PermissionsEnum.MeterReading
                              ])" (change)="
                              onChangePermission([
                                  PermissionsEnum.MeterReading
                                ],
                                $event
                              )
                          " />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="permission-options">
                  <div class="permission-item">
                    <input type="checkbox" id="meter-reading-mobile" class="custom-checkbox"
                      [checked]="isChecked([PermissionsEnum.MeterReading])"
                      (change)="onChangePermission([PermissionsEnum.MeterReading], $event)">
                    <label for="meter-reading-mobile" class="permission-label">{{ "COMMON.MBC_DETAILS.METER_READING" |
                      translate }}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- SEARCH ENGINE -->
          <div class="d-flex flex-column gap-3 permission-container no-group-perm-container">
            <div class="permission-header">
              <h3 class="permission-title">{{ 'COMMON.SEARCH_ENGINE' | translate}}</h3>
              <label class="switch">
                <input type="checkbox" [checked]="
                          isChecked([
                              PermissionsEnum.SearchEngine,
                          ])" (change)="
                          onChangePermission(
                              [
                                  PermissionsEnum.SearchEngine,
           
                              ],
                              $event
                          )
                      " />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="permission-options">
              <div class="permission-item">
                <input type="checkbox" id="search-engine" class="custom-checkbox"
                  [checked]="isChecked([PermissionsEnum.SearchEngine])"
                  (change)="onChangePermission([PermissionsEnum.SearchEngine], $event)">
                <label for="search-engine" class="permission-label">{{ "COMMON.SEARCH_ENGINE" | translate }}</label>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

<div class="modal fade" id="addRoleModal" tabindex="-1" aria-labelledby="addRoleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header edit-modal-header">
        <h5 class="modal-title" id="tsModalTitle">{{ "ROLE_MANAGEMENT.ADD_ROLE" | translate }}</h5>
      </div>
      <div class="modal-body edit-modal-body">
        <span>{{ "ROLE_MANAGEMENT.ROLE_NAME" | translate }}</span>
        <label for="nameInput">
          <input id="nameInput" type="text" [(ngModel)]="newRole.name"
            [placeholder]="'ROLE_MANAGEMENT.ROLE_NAME' | translate" />
        </label>
        <span>{{ "ROLE_MANAGEMENT.SYSTEM_COMPONENT" | translate }}</span>
        <div class="dropdown">
          <button (click)="toggleSystemComponentDropdown()" class="dropdown-button">
            {{ selectedSystemComponentText | translate }}
            <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
          </button>
          <div *ngIf="systemComponentDropdownOpened" class="dropdown-options">
            <div class="dropdown-option dropdown-header" disabled="true">
              <span>{{ "ROLE_MANAGEMENT.SYSTEM_COMPONENT" | translate }}</span>
            </div>
            <div (click)="selectSystemComponent(SystemComponent.Admin)" class="dropdown-option">
              <span>{{ "ROLE_MANAGEMENT.ADMIN" | translate }}</span>
              <svg *ngIf="newRole.systemComponent === SystemComponent.Admin" width="12" height="12" viewBox="0 0 12 12"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div (click)="selectSystemComponent(SystemComponent.Mobile)" class="dropdown-option">
              <span>{{ "ROLE_MANAGEMENT.MOBILE" | translate }}</span>
              <svg *ngIf="newRole.systemComponent === SystemComponent.Mobile" width="12" height="12" viewBox="0 0 12 12"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer edit-modal-footer">
        <div>
          <button class="cancel" data-bs-dismiss="modal">
            {{ "COMMON.CANCEL" | translate }}
          </button>
        </div>
        <div>
          <button class="save" (click)="save()" data-bs-dismiss="modal">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
